"use strict";

Object.defineProperty(exports, "__esModule", {
    value: !0
});

var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
}

function createCommonjsModule(fn, module) {
    return fn(module = {
        exports: {}
    }, module.exports), module.exports;
}

var match, version, check = function(it) {
    return it && it.Math == Math && it;
}, global_1 = check("object" == typeof globalThis && globalThis) || check("object" == typeof window && window) || check("object" == typeof self && self) || check("object" == typeof commonjsGlobal && commonjsGlobal) || function() {
    return this;
}() || Function("return this")(), fails = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return !0;
    }
}, descriptors = !fails((function() {
    return 7 != Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1];
})), functionBindNative = !fails((function() {
    var test = function() {}.bind();
    return "function" != typeof test || test.hasOwnProperty("prototype");
})), call = Function.prototype.call, functionCall = functionBindNative ? call.bind(call) : function() {
    return call.apply(call, arguments);
}, $propertyIsEnumerable = {}.propertyIsEnumerable, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, objectPropertyIsEnumerable = {
    f: getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
        1: 2
    }, 1) ? function(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable
}, createPropertyDescriptor = function(bitmap, value) {
    return {
        enumerable: !(1 & bitmap),
        configurable: !(2 & bitmap),
        writable: !(4 & bitmap),
        value: value
    };
}, FunctionPrototype = Function.prototype, call$1 = FunctionPrototype.call, uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call$1, call$1), functionUncurryThis = functionBindNative ? uncurryThisWithBind : function(fn) {
    return function() {
        return call$1.apply(fn, arguments);
    };
}, toString = functionUncurryThis({}.toString), stringSlice = functionUncurryThis("".slice), classofRaw = function(it) {
    return stringSlice(toString(it), 8, -1);
}, $Object = Object, split = functionUncurryThis("".split), indexedObject = fails((function() {
    return !$Object("z").propertyIsEnumerable(0);
})) ? function(it) {
    return "String" == classofRaw(it) ? split(it, "") : $Object(it);
} : $Object, isNullOrUndefined = function(it) {
    return null == it;
}, $TypeError = TypeError, requireObjectCoercible = function(it) {
    if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
    return it;
}, toIndexedObject = function(it) {
    return indexedObject(requireObjectCoercible(it));
}, documentAll = "object" == typeof document && document.all, documentAll_1 = {
    all: documentAll,
    IS_HTMLDDA: void 0 === documentAll && void 0 !== documentAll
}, documentAll$1 = documentAll_1.all, isCallable = documentAll_1.IS_HTMLDDA ? function(argument) {
    return "function" == typeof argument || argument === documentAll$1;
} : function(argument) {
    return "function" == typeof argument;
}, documentAll$2 = documentAll_1.all, isObject = documentAll_1.IS_HTMLDDA ? function(it) {
    return "object" == typeof it ? null !== it : isCallable(it) || it === documentAll$2;
} : function(it) {
    return "object" == typeof it ? null !== it : isCallable(it);
}, aFunction = function(argument) {
    return isCallable(argument) ? argument : void 0;
}, getBuiltIn = function(namespace, method) {
    return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
}, objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf), engineUserAgent = getBuiltIn("navigator", "userAgent") || "", process = global_1.process, Deno$1 = global_1.Deno, versions = process && process.versions || Deno$1 && Deno$1.version, v8 = versions && versions.v8;

v8 && (version = (match = v8.split("."))[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1])), 
!version && engineUserAgent && (!(match = engineUserAgent.match(/Edge\/(\d+)/)) || match[1] >= 74) && (match = engineUserAgent.match(/Chrome\/(\d+)/)) && (version = +match[1]);

var engineV8Version = version, symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails((function() {
    var symbol = Symbol();
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && engineV8Version && engineV8Version < 41;
})), useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && "symbol" == typeof Symbol.iterator, $Object$1 = Object, isSymbol = useSymbolAsUid ? function(it) {
    return "symbol" == typeof it;
} : function(it) {
    var $Symbol = getBuiltIn("Symbol");
    return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$1(it));
}, $String = String, tryToString = function(argument) {
    try {
        return $String(argument);
    } catch (error) {
        return "Object";
    }
}, $TypeError$1 = TypeError, aCallable = function(argument) {
    if (isCallable(argument)) return argument;
    throw $TypeError$1(tryToString(argument) + " is not a function");
}, getMethod = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? void 0 : aCallable(func);
}, $TypeError$2 = TypeError, defineProperty = Object.defineProperty, defineGlobalProperty = function(key, value) {
    try {
        defineProperty(global_1, key, {
            value: value,
            configurable: !0,
            writable: !0
        });
    } catch (error) {
        global_1[key] = value;
    }
    return value;
}, sharedStore = global_1["__core-js_shared__"] || defineGlobalProperty("__core-js_shared__", {}), shared = createCommonjsModule((function(module) {
    (module.exports = function(key, value) {
        return sharedStore[key] || (sharedStore[key] = void 0 !== value ? value : {});
    })("versions", []).push({
        version: "3.26.1",
        mode: "global",
        copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
})), $Object$2 = Object, toObject = function(argument) {
    return $Object$2(requireObjectCoercible(argument));
}, hasOwnProperty = functionUncurryThis({}.hasOwnProperty), hasOwnProperty_1 = Object.hasOwn || function(it, key) {
    return hasOwnProperty(toObject(it), key);
}, id = 0, postfix = Math.random(), toString$1 = functionUncurryThis(1..toString), uid = function(key) {
    return "Symbol(" + (void 0 === key ? "" : key) + ")_" + toString$1(++id + postfix, 36);
}, WellKnownSymbolsStore = shared("wks"), Symbol$1 = global_1.Symbol, symbolFor = Symbol$1 && Symbol$1.for, createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid, wellKnownSymbol = function(name) {
    if (!hasOwnProperty_1(WellKnownSymbolsStore, name) || !symbolConstructorDetection && "string" != typeof WellKnownSymbolsStore[name]) {
        var description = "Symbol." + name;
        symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? WellKnownSymbolsStore[name] = Symbol$1[name] : WellKnownSymbolsStore[name] = useSymbolAsUid && symbolFor ? symbolFor(description) : createWellKnownSymbol(description);
    }
    return WellKnownSymbolsStore[name];
}, $TypeError$3 = TypeError, TO_PRIMITIVE = wellKnownSymbol("toPrimitive"), toPrimitive = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var result, exoticToPrim = getMethod(input, TO_PRIMITIVE);
    if (exoticToPrim) {
        if (void 0 === pref && (pref = "default"), result = functionCall(exoticToPrim, input, pref), 
        !isObject(result) || isSymbol(result)) return result;
        throw $TypeError$3("Can't convert object to primitive value");
    }
    return void 0 === pref && (pref = "number"), function(input, pref) {
        var fn, val;
        if ("string" === pref && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
        if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
        if ("string" !== pref && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
        throw $TypeError$2("Can't convert object to primitive value");
    }(input, pref);
}, toPropertyKey = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
}, document$1 = global_1.document, EXISTS = isObject(document$1) && isObject(document$1.createElement), documentCreateElement = function(it) {
    return EXISTS ? document$1.createElement(it) : {};
}, ie8DomDefine = !descriptors && !fails((function() {
    return 7 != Object.defineProperty(documentCreateElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a;
})), $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, objectGetOwnPropertyDescriptor = {
    f: descriptors ? $getOwnPropertyDescriptor : function(O, P) {
        if (O = toIndexedObject(O), P = toPropertyKey(P), ie8DomDefine) try {
            return $getOwnPropertyDescriptor(O, P);
        } catch (error) {}
        if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
    }
}, v8PrototypeDefineBug = descriptors && fails((function() {
    return 42 != Object.defineProperty((function() {}), "prototype", {
        value: 42,
        writable: !1
    }).prototype;
})), $String$1 = String, $TypeError$4 = TypeError, anObject = function(argument) {
    if (isObject(argument)) return argument;
    throw $TypeError$4($String$1(argument) + " is not an object");
}, $TypeError$5 = TypeError, $defineProperty = Object.defineProperty, $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor, objectDefineProperty = {
    f: descriptors ? v8PrototypeDefineBug ? function(O, P, Attributes) {
        if (anObject(O), P = toPropertyKey(P), anObject(Attributes), "function" == typeof O && "prototype" === P && "value" in Attributes && "writable" in Attributes && !Attributes.writable) {
            var current = $getOwnPropertyDescriptor$1(O, P);
            current && current.writable && (O[P] = Attributes.value, Attributes = {
                configurable: "configurable" in Attributes ? Attributes.configurable : current.configurable,
                enumerable: "enumerable" in Attributes ? Attributes.enumerable : current.enumerable,
                writable: !1
            });
        }
        return $defineProperty(O, P, Attributes);
    } : $defineProperty : function(O, P, Attributes) {
        if (anObject(O), P = toPropertyKey(P), anObject(Attributes), ie8DomDefine) try {
            return $defineProperty(O, P, Attributes);
        } catch (error) {}
        if ("get" in Attributes || "set" in Attributes) throw $TypeError$5("Accessors not supported");
        return "value" in Attributes && (O[P] = Attributes.value), O;
    }
}, createNonEnumerableProperty = descriptors ? function(object, key, value) {
    return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    return object[key] = value, object;
}, FunctionPrototype$1 = Function.prototype, getDescriptor = descriptors && Object.getOwnPropertyDescriptor, EXISTS$1 = hasOwnProperty_1(FunctionPrototype$1, "name"), functionName = {
    EXISTS: EXISTS$1,
    PROPER: EXISTS$1 && "something" === function() {}.name,
    CONFIGURABLE: EXISTS$1 && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, "name").configurable)
}, functionToString = functionUncurryThis(Function.toString);

isCallable(sharedStore.inspectSource) || (sharedStore.inspectSource = function(it) {
    return functionToString(it);
});

var set, get, has, inspectSource = sharedStore.inspectSource, WeakMap = global_1.WeakMap, weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap)), keys = shared("keys"), sharedKey = function(key) {
    return keys[key] || (keys[key] = uid(key));
}, hiddenKeys = {}, TypeError$1 = global_1.TypeError, WeakMap$1 = global_1.WeakMap;

if (weakMapBasicDetection || sharedStore.state) {
    var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1);
    store$1.get = store$1.get, store$1.has = store$1.has, store$1.set = store$1.set, 
    set = function(it, metadata) {
        if (store$1.has(it)) throw TypeError$1("Object already initialized");
        return metadata.facade = it, store$1.set(it, metadata), metadata;
    }, get = function(it) {
        return store$1.get(it) || {};
    }, has = function(it) {
        return store$1.has(it);
    };
} else {
    var STATE = sharedKey("state");
    hiddenKeys[STATE] = !0, set = function(it, metadata) {
        if (hasOwnProperty_1(it, STATE)) throw TypeError$1("Object already initialized");
        return metadata.facade = it, createNonEnumerableProperty(it, STATE, metadata), metadata;
    }, get = function(it) {
        return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
    }, has = function(it) {
        return hasOwnProperty_1(it, STATE);
    };
}

var internalState = {
    set: set,
    get: get,
    has: has,
    enforce: function(it) {
        return has(it) ? get(it) : set(it, {});
    },
    getterFor: function(TYPE) {
        return function(it) {
            var state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError$1("Incompatible receiver, " + TYPE + " required");
            return state;
        };
    }
}, makeBuiltIn_1 = createCommonjsModule((function(module) {
    var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE, enforceInternalState = internalState.enforce, getInternalState = internalState.get, defineProperty = Object.defineProperty, CONFIGURABLE_LENGTH = descriptors && !fails((function() {
        return 8 !== defineProperty((function() {}), "length", {
            value: 8
        }).length;
    })), TEMPLATE = String(String).split("String"), makeBuiltIn = module.exports = function(value, name, options) {
        "Symbol(" === String(name).slice(0, 7) && (name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), 
        options && options.getter && (name = "get " + name), options && options.setter && (name = "set " + name), 
        (!hasOwnProperty_1(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) && (descriptors ? defineProperty(value, "name", {
            value: name,
            configurable: !0
        }) : value.name = name), CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, "arity") && value.length !== options.arity && defineProperty(value, "length", {
            value: options.arity
        });
        try {
            options && hasOwnProperty_1(options, "constructor") && options.constructor ? descriptors && defineProperty(value, "prototype", {
                writable: !1
            }) : value.prototype && (value.prototype = void 0);
        } catch (error) {}
        var state = enforceInternalState(value);
        return hasOwnProperty_1(state, "source") || (state.source = TEMPLATE.join("string" == typeof name ? name : "")), 
        value;
    };
    Function.prototype.toString = makeBuiltIn((function() {
        return isCallable(this) && getInternalState(this).source || inspectSource(this);
    }), "toString");
})), defineBuiltIn = function(O, key, value, options) {
    options || (options = {});
    var simple = options.enumerable, name = void 0 !== options.name ? options.name : key;
    if (isCallable(value) && makeBuiltIn_1(value, name, options), options.global) simple ? O[key] = value : defineGlobalProperty(key, value); else {
        try {
            options.unsafe ? O[key] && (simple = !0) : delete O[key];
        } catch (error) {}
        simple ? O[key] = value : objectDefineProperty.f(O, key, {
            value: value,
            enumerable: !1,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
}, ceil = Math.ceil, floor = Math.floor, mathTrunc = Math.trunc || function(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
}, toIntegerOrInfinity = function(argument) {
    var number = +argument;
    return number != number || 0 === number ? 0 : mathTrunc(number);
}, max = Math.max, min = Math.min, toAbsoluteIndex = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
}, min$1 = Math.min, toLength = function(argument) {
    return argument > 0 ? min$1(toIntegerOrInfinity(argument), 9007199254740991) : 0;
}, lengthOfArrayLike = function(obj) {
    return toLength(obj.length);
}, createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var value, O = toIndexedObject($this), length = lengthOfArrayLike(O), index = toAbsoluteIndex(fromIndex, length);
        if (IS_INCLUDES && el != el) {
            for (;length > index; ) if ((value = O[index++]) != value) return !0;
        } else for (;length > index; index++) if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        return !IS_INCLUDES && -1;
    };
}, indexOf = {
    includes: createMethod(!0),
    indexOf: createMethod(!1)
}.indexOf, push = functionUncurryThis([].push), objectKeysInternal = function(object, names) {
    var key, O = toIndexedObject(object), i = 0, result = [];
    for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key);
    for (;names.length > i; ) hasOwnProperty_1(O, key = names[i++]) && (~indexOf(result, key) || push(result, key));
    return result;
}, enumBugKeys = [ "constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf" ], hiddenKeys$1 = enumBugKeys.concat("length", "prototype"), objectGetOwnPropertyNames = {
    f: Object.getOwnPropertyNames || function(O) {
        return objectKeysInternal(O, hiddenKeys$1);
    }
}, objectGetOwnPropertySymbols = {
    f: Object.getOwnPropertySymbols
}, concat = functionUncurryThis([].concat), ownKeys = getBuiltIn("Reflect", "ownKeys") || function(it) {
    var keys = objectGetOwnPropertyNames.f(anObject(it)), getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
}, copyConstructorProperties = function(target, source, exceptions) {
    for (var keys = ownKeys(source), defineProperty = objectDefineProperty.f, getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f, i = 0; i < keys.length; i++) {
        var key = keys[i];
        hasOwnProperty_1(target, key) || exceptions && hasOwnProperty_1(exceptions, key) || defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
}, replacement = /#|\.prototype\./, isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL || value != NATIVE && (isCallable(detection) ? fails(detection) : !!detection);
}, normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
}, data = isForced.data = {}, NATIVE = isForced.NATIVE = "N", POLYFILL = isForced.POLYFILL = "P", isForced_1 = isForced, getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f, _export = function(options, source) {
    var target, key, targetProperty, sourceProperty, descriptor, TARGET = options.target, GLOBAL = options.global, STATIC = options.stat;
    if (target = GLOBAL ? global_1 : STATIC ? global_1[TARGET] || defineGlobalProperty(TARGET, {}) : (global_1[TARGET] || {}).prototype) for (key in source) {
        if (sourceProperty = source[key], targetProperty = options.dontCallGetSet ? (descriptor = getOwnPropertyDescriptor$1(target, key)) && descriptor.value : target[key], 
        !isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced) && void 0 !== targetProperty) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        (options.sham || targetProperty && targetProperty.sham) && createNonEnumerableProperty(sourceProperty, "sham", !0), 
        defineBuiltIn(target, key, sourceProperty, options);
    }
}, defineProperty$1 = objectDefineProperty.f, TO_STRING_TAG = wellKnownSymbol("toStringTag"), setToStringTag = function(target, TAG, STATIC) {
    target && !STATIC && (target = target.prototype), target && !hasOwnProperty_1(target, TO_STRING_TAG) && defineProperty$1(target, TO_STRING_TAG, {
        configurable: !0,
        value: TAG
    });
};

_export({
    global: !0
}, {
    Reflect: {}
}), setToStringTag(global_1.Reflect, "Reflect", !0);

var test = {};

test[wellKnownSymbol("toStringTag")] = "z";

var toStringTagSupport = "[object z]" === String(test), TO_STRING_TAG$2 = wellKnownSymbol("toStringTag"), $Object$3 = Object, CORRECT_ARGUMENTS = "Arguments" == classofRaw(function() {
    return arguments;
}()), classof = toStringTagSupport ? classofRaw : function(it) {
    var O, tag, result;
    return void 0 === it ? "Undefined" : null === it ? "Null" : "string" == typeof (tag = function(it, key) {
        try {
            return it[key];
        } catch (error) {}
    }(O = $Object$3(it), TO_STRING_TAG$2)) ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : "Object" == (result = classofRaw(O)) && isCallable(O.callee) ? "Arguments" : result;
}, objectToString = toStringTagSupport ? {}.toString : function() {
    return "[object " + classof(this) + "]";
};

toStringTagSupport || defineBuiltIn(Object.prototype, "toString", objectToString, {
    unsafe: !0
});

var isDataDescriptor = function(descriptor) {
    return void 0 !== descriptor && (hasOwnProperty_1(descriptor, "value") || hasOwnProperty_1(descriptor, "writable"));
}, correctPrototypeGetter = !fails((function() {
    function F() {}
    return F.prototype.constructor = null, Object.getPrototypeOf(new F) !== F.prototype;
})), IE_PROTO = sharedKey("IE_PROTO"), $Object$4 = Object, ObjectPrototype = $Object$4.prototype, objectGetPrototypeOf = correctPrototypeGetter ? $Object$4.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwnProperty_1(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    return isCallable(constructor) && object instanceof constructor ? constructor.prototype : object instanceof $Object$4 ? ObjectPrototype : null;
};

_export({
    target: "Reflect",
    stat: !0
}, {
    get: function get$1(target, propertyKey) {
        var descriptor, prototype, receiver = arguments.length < 3 ? target : arguments[2];
        return anObject(target) === receiver ? target[propertyKey] : (descriptor = objectGetOwnPropertyDescriptor.f(target, propertyKey)) ? isDataDescriptor(descriptor) ? descriptor.value : void 0 === descriptor.get ? void 0 : functionCall(descriptor.get, receiver) : isObject(prototype = objectGetPrototypeOf(target)) ? get$1(prototype, propertyKey, receiver) : void 0;
    }
});

var FunctionPrototype$2 = Function.prototype, apply = FunctionPrototype$2.apply, call$2 = FunctionPrototype$2.call, functionApply = "object" == typeof Reflect && Reflect.apply || (functionBindNative ? call$2.bind(apply) : function() {
    return call$2.apply(apply, arguments);
}), $String$2 = String, $TypeError$6 = TypeError, objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var setter, CORRECT_SETTER = !1, test = {};
    try {
        (setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(test, []), 
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function(O, proto) {
        return anObject(O), function(argument) {
            if ("object" == typeof argument || isCallable(argument)) return argument;
            throw $TypeError$6("Can't set " + $String$2(argument) + " as a prototype");
        }(proto), CORRECT_SETTER ? setter(O, proto) : O.__proto__ = proto, O;
    };
}() : void 0), defineProperty$2 = objectDefineProperty.f, proxyAccessor = function(Target, Source, key) {
    key in Target || defineProperty$2(Target, key, {
        configurable: !0,
        get: function() {
            return Source[key];
        },
        set: function(it) {
            Source[key] = it;
        }
    });
}, inheritIfRequired = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    return objectSetPrototypeOf && isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype && objectSetPrototypeOf($this, NewTargetPrototype), 
    $this;
}, $String$3 = String, toString_1 = function(argument) {
    if ("Symbol" === classof(argument)) throw TypeError("Cannot convert a Symbol value to a string");
    return $String$3(argument);
}, normalizeStringArgument = function(argument, $default) {
    return void 0 === argument ? arguments.length < 2 ? "" : $default : toString_1(argument);
}, installErrorCause = function(O, options) {
    isObject(options) && "cause" in options && createNonEnumerableProperty(O, "cause", options.cause);
}, $Error = Error, replace = functionUncurryThis("".replace), TEST = String($Error("zxcasd").stack), V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/, IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST), errorStackClear = function(stack, dropEntries) {
    if (IS_V8_OR_CHAKRA_STACK && "string" == typeof stack && !$Error.prepareStackTrace) for (;dropEntries--; ) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
}, errorStackInstallable = !fails((function() {
    var error = Error("a");
    return !("stack" in error) || (Object.defineProperty(error, "stack", createPropertyDescriptor(1, 7)), 
    7 !== error.stack);
})), wrapErrorConstructorWithCause = function(FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
    var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1, path = FULL_NAME.split("."), ERROR_NAME = path[path.length - 1], OriginalError = getBuiltIn.apply(null, path);
    if (OriginalError) {
        var OriginalErrorPrototype = OriginalError.prototype;
        if (hasOwnProperty_1(OriginalErrorPrototype, "cause") && delete OriginalErrorPrototype.cause, 
        !FORCED) return OriginalError;
        var BaseError = getBuiltIn("Error"), WrappedError = wrapper((function(a, b) {
            var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, void 0), result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError;
            return void 0 !== message && createNonEnumerableProperty(result, "message", message), 
            errorStackInstallable && createNonEnumerableProperty(result, "stack", errorStackClear(result.stack, 2)), 
            this && objectIsPrototypeOf(OriginalErrorPrototype, this) && inheritIfRequired(result, this, WrappedError), 
            arguments.length > OPTIONS_POSITION && installErrorCause(result, arguments[OPTIONS_POSITION]), 
            result;
        }));
        WrappedError.prototype = OriginalErrorPrototype, "Error" !== ERROR_NAME ? objectSetPrototypeOf ? objectSetPrototypeOf(WrappedError, BaseError) : copyConstructorProperties(WrappedError, BaseError, {
            name: !0
        }) : descriptors && "stackTraceLimit" in OriginalError && (proxyAccessor(WrappedError, OriginalError, "stackTraceLimit"), 
        proxyAccessor(WrappedError, OriginalError, "prepareStackTrace")), copyConstructorProperties(WrappedError, OriginalError);
        try {
            OriginalErrorPrototype.name !== ERROR_NAME && createNonEnumerableProperty(OriginalErrorPrototype, "name", ERROR_NAME), 
            OriginalErrorPrototype.constructor = WrappedError;
        } catch (error) {}
        return WrappedError;
    }
}, WebAssembly = global_1.WebAssembly, FORCED = 7 !== Error("e", {
    cause: 7
}).cause, exportGlobalErrorCauseWrapper = function(ERROR_NAME, wrapper) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED), _export({
        global: !0,
        constructor: !0,
        arity: 1,
        forced: FORCED
    }, O);
}, exportWebAssemblyErrorCauseWrapper = function(ERROR_NAME, wrapper) {
    if (WebAssembly && WebAssembly[ERROR_NAME]) {
        var O = {};
        O[ERROR_NAME] = wrapErrorConstructorWithCause("WebAssembly." + ERROR_NAME, wrapper, FORCED), 
        _export({
            target: "WebAssembly",
            stat: !0,
            constructor: !0,
            arity: 1,
            forced: FORCED
        }, O);
    }
};

exportGlobalErrorCauseWrapper("Error", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportGlobalErrorCauseWrapper("EvalError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportGlobalErrorCauseWrapper("RangeError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportGlobalErrorCauseWrapper("ReferenceError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportGlobalErrorCauseWrapper("SyntaxError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportGlobalErrorCauseWrapper("TypeError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportGlobalErrorCauseWrapper("URIError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportWebAssemblyErrorCauseWrapper("CompileError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportWebAssemblyErrorCauseWrapper("LinkError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
})), exportWebAssemblyErrorCauseWrapper("RuntimeError", (function(init) {
    return function(message) {
        return functionApply(init, this, arguments);
    };
}));

var objectKeys = Object.keys || function(O) {
    return objectKeysInternal(O, enumBugKeys);
}, $assign = Object.assign, defineProperty$3 = Object.defineProperty, concat$1 = functionUncurryThis([].concat), objectAssign = !$assign || fails((function() {
    if (descriptors && 1 !== $assign({
        b: 1
    }, $assign(defineProperty$3({}, "a", {
        enumerable: !0,
        get: function() {
            defineProperty$3(this, "b", {
                value: 3,
                enumerable: !1
            });
        }
    }), {
        b: 2
    })).b) return !0;
    var A = {}, B = {}, symbol = Symbol();
    return A[symbol] = 7, "abcdefghijklmnopqrst".split("").forEach((function(chr) {
        B[chr] = chr;
    })), 7 != $assign({}, A)[symbol] || "abcdefghijklmnopqrst" != objectKeys($assign({}, B)).join("");
})) ? function(target, source) {
    for (var T = toObject(target), argumentsLength = arguments.length, index = 1, getOwnPropertySymbols = objectGetOwnPropertySymbols.f, propertyIsEnumerable = objectPropertyIsEnumerable.f; argumentsLength > index; ) for (var key, S = indexedObject(arguments[index++]), keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S), length = keys.length, j = 0; length > j; ) key = keys[j++], 
    descriptors && !functionCall(propertyIsEnumerable, S, key) || (T[key] = S[key]);
    return T;
} : $assign;

_export({
    target: "Object",
    stat: !0,
    arity: 2,
    forced: Object.assign !== objectAssign
}, {
    assign: objectAssign
});

var activeXDocument, objectDefineProperties = {
    f: descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function(O, Properties) {
        anObject(O);
        for (var key, props = toIndexedObject(Properties), keys = objectKeys(Properties), length = keys.length, index = 0; length > index; ) objectDefineProperty.f(O, key = keys[index++], props[key]);
        return O;
    }
}, html = getBuiltIn("document", "documentElement"), IE_PROTO$1 = sharedKey("IE_PROTO"), EmptyConstructor = function() {}, scriptTag = function(content) {
    return "<script>" + content + "<\/script>";
}, NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag("")), activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    return activeXDocument = null, temp;
}, NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    var iframeDocument, iframe;
    NullProtoObject = "undefined" != typeof document ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : ((iframe = documentCreateElement("iframe")).style.display = "none", 
    html.appendChild(iframe), iframe.src = String("javascript:"), (iframeDocument = iframe.contentWindow.document).open(), 
    iframeDocument.write(scriptTag("document.F=Object")), iframeDocument.close(), iframeDocument.F) : NullProtoObjectViaActiveX(activeXDocument);
    for (var length = enumBugKeys.length; length--; ) delete NullProtoObject.prototype[enumBugKeys[length]];
    return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = !0;

var objectCreate = Object.create || function(O, Properties) {
    var result;
    return null !== O ? (EmptyConstructor.prototype = anObject(O), result = new EmptyConstructor, 
    EmptyConstructor.prototype = null, result[IE_PROTO$1] = O) : result = NullProtoObject(), 
    void 0 === Properties ? result : objectDefineProperties.f(result, Properties);
}, createProperty = function(object, key, value) {
    var propertyKey = toPropertyKey(key);
    propertyKey in object ? objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value)) : object[propertyKey] = value;
}, $Array = Array, max$1 = Math.max, arraySliceSimple = function(O, start, end) {
    for (var length = lengthOfArrayLike(O), k = toAbsoluteIndex(start, length), fin = toAbsoluteIndex(void 0 === end ? length : end, length), result = $Array(max$1(fin - k, 0)), n = 0; k < fin; k++, 
    n++) createProperty(result, n, O[k]);
    return result.length = n, result;
}, $getOwnPropertyNames = objectGetOwnPropertyNames.f, windowNames = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], objectGetOwnPropertyNamesExternal = {
    f: function(it) {
        return windowNames && "Window" == classofRaw(it) ? function(it) {
            try {
                return $getOwnPropertyNames(it);
            } catch (error) {
                return arraySliceSimple(windowNames);
            }
        }(it) : $getOwnPropertyNames(toIndexedObject(it));
    }
}, wellKnownSymbolWrapped = {
    f: wellKnownSymbol
}, path = global_1, defineProperty$4 = objectDefineProperty.f, wellKnownSymbolDefine = function(NAME) {
    var Symbol = path.Symbol || (path.Symbol = {});
    hasOwnProperty_1(Symbol, NAME) || defineProperty$4(Symbol, NAME, {
        value: wellKnownSymbolWrapped.f(NAME)
    });
}, functionUncurryThisClause = function(fn) {
    if ("Function" === classofRaw(fn)) return functionUncurryThis(fn);
}, bind = functionUncurryThisClause(functionUncurryThisClause.bind), functionBindContext = function(fn, that) {
    return aCallable(fn), void 0 === that ? fn : functionBindNative ? bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
}, isArray = Array.isArray || function(argument) {
    return "Array" == classofRaw(argument);
}, noop = function() {}, empty = [], construct = getBuiltIn("Reflect", "construct"), constructorRegExp = /^\s*(?:class|function)\b/, exec = functionUncurryThis(constructorRegExp.exec), INCORRECT_TO_STRING = !constructorRegExp.exec(noop), isConstructorModern = function(argument) {
    if (!isCallable(argument)) return !1;
    try {
        return construct(noop, empty, argument), !0;
    } catch (error) {
        return !1;
    }
}, isConstructorLegacy = function(argument) {
    if (!isCallable(argument)) return !1;
    switch (classof(argument)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
        return !0;
    }
};

isConstructorLegacy.sham = !0;

var isConstructor = !construct || fails((function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern((function() {
        called = !0;
    })) || called;
})) ? isConstructorLegacy : isConstructorModern, SPECIES = wellKnownSymbol("species"), $Array$1 = Array, arraySpeciesCreate = function(originalArray, length) {
    return new (function(originalArray) {
        var C;
        return isArray(originalArray) && (C = originalArray.constructor, (isConstructor(C) && (C === $Array$1 || isArray(C.prototype)) || isObject(C) && null === (C = C[SPECIES])) && (C = void 0)), 
        void 0 === C ? $Array$1 : C;
    }(originalArray))(0 === length ? 0 : length);
}, push$1 = functionUncurryThis([].push), createMethod$1 = function(TYPE) {
    var IS_MAP = 1 == TYPE, IS_FILTER = 2 == TYPE, IS_SOME = 3 == TYPE, IS_EVERY = 4 == TYPE, IS_FIND_INDEX = 6 == TYPE, IS_FILTER_REJECT = 7 == TYPE, NO_HOLES = 5 == TYPE || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        for (var value, result, O = toObject($this), self = indexedObject(O), boundFunction = functionBindContext(callbackfn, that), length = lengthOfArrayLike(self), index = 0, create = specificCreate || arraySpeciesCreate, target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : void 0; length > index; index++) if ((NO_HOLES || index in self) && (result = boundFunction(value = self[index], index, O), 
        TYPE)) if (IS_MAP) target[index] = result; else if (result) switch (TYPE) {
          case 3:
            return !0;

          case 5:
            return value;

          case 6:
            return index;

          case 2:
            push$1(target, value);
        } else switch (TYPE) {
          case 4:
            return !1;

          case 7:
            push$1(target, value);
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
}, $forEach = {
    forEach: createMethod$1(0),
    map: createMethod$1(1),
    filter: createMethod$1(2),
    some: createMethod$1(3),
    every: createMethod$1(4),
    find: createMethod$1(5),
    findIndex: createMethod$1(6),
    filterReject: createMethod$1(7)
}.forEach, HIDDEN = sharedKey("hidden"), setInternalState = internalState.set, getInternalState = internalState.getterFor("Symbol"), ObjectPrototype$1 = Object.prototype, $Symbol = global_1.Symbol, SymbolPrototype = $Symbol && $Symbol.prototype, TypeError$2 = global_1.TypeError, QObject = global_1.QObject, nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f, nativeDefineProperty = objectDefineProperty.f, nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f, nativePropertyIsEnumerable = objectPropertyIsEnumerable.f, push$2 = functionUncurryThis([].push), AllSymbols = shared("symbols"), ObjectPrototypeSymbols = shared("op-symbols"), WellKnownSymbolsStore$1 = shared("wks"), USE_SETTER = !QObject || !QObject.prototype || !QObject.prototype.findChild, setSymbolDescriptor = descriptors && fails((function() {
    return 7 != objectCreate(nativeDefineProperty({}, "a", {
        get: function() {
            return nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a;
})) ? function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
    ObjectPrototypeDescriptor && delete ObjectPrototype$1[P], nativeDefineProperty(O, P, Attributes), 
    ObjectPrototypeDescriptor && O !== ObjectPrototype$1 && nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
} : nativeDefineProperty, wrap = function(tag, description) {
    var symbol = AllSymbols[tag] = objectCreate(SymbolPrototype);
    return setInternalState(symbol, {
        type: "Symbol",
        tag: tag,
        description: description
    }), descriptors || (symbol.description = description), symbol;
}, $defineProperty$1 = function(O, P, Attributes) {
    O === ObjectPrototype$1 && $defineProperty$1(ObjectPrototypeSymbols, P, Attributes), 
    anObject(O);
    var key = toPropertyKey(P);
    return anObject(Attributes), hasOwnProperty_1(AllSymbols, key) ? (Attributes.enumerable ? (hasOwnProperty_1(O, HIDDEN) && O[HIDDEN][key] && (O[HIDDEN][key] = !1), 
    Attributes = objectCreate(Attributes, {
        enumerable: createPropertyDescriptor(0, !1)
    })) : (hasOwnProperty_1(O, HIDDEN) || nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {})), 
    O[HIDDEN][key] = !0), setSymbolDescriptor(O, key, Attributes)) : nativeDefineProperty(O, key, Attributes);
}, $defineProperties = function(O, Properties) {
    anObject(O);
    var properties = toIndexedObject(Properties), keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
    return $forEach(keys, (function(key) {
        descriptors && !functionCall($propertyIsEnumerable$1, properties, key) || $defineProperty$1(O, key, properties[key]);
    })), O;
}, $propertyIsEnumerable$1 = function(V) {
    var P = toPropertyKey(V), enumerable = functionCall(nativePropertyIsEnumerable, this, P);
    return !(this === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, P) && !hasOwnProperty_1(ObjectPrototypeSymbols, P)) && (!(enumerable || !hasOwnProperty_1(this, P) || !hasOwnProperty_1(AllSymbols, P) || hasOwnProperty_1(this, HIDDEN) && this[HIDDEN][P]) || enumerable);
}, $getOwnPropertyDescriptor$2 = function(O, P) {
    var it = toIndexedObject(O), key = toPropertyKey(P);
    if (it !== ObjectPrototype$1 || !hasOwnProperty_1(AllSymbols, key) || hasOwnProperty_1(ObjectPrototypeSymbols, key)) {
        var descriptor = nativeGetOwnPropertyDescriptor(it, key);
        return !descriptor || !hasOwnProperty_1(AllSymbols, key) || hasOwnProperty_1(it, HIDDEN) && it[HIDDEN][key] || (descriptor.enumerable = !0), 
        descriptor;
    }
}, $getOwnPropertyNames$1 = function(O) {
    var names = nativeGetOwnPropertyNames(toIndexedObject(O)), result = [];
    return $forEach(names, (function(key) {
        hasOwnProperty_1(AllSymbols, key) || hasOwnProperty_1(hiddenKeys, key) || push$2(result, key);
    })), result;
}, $getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1, names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O)), result = [];
    return $forEach(names, (function(key) {
        !hasOwnProperty_1(AllSymbols, key) || IS_OBJECT_PROTOTYPE && !hasOwnProperty_1(ObjectPrototype$1, key) || push$2(result, AllSymbols[key]);
    })), result;
};

symbolConstructorDetection || (SymbolPrototype = ($Symbol = function() {
    if (objectIsPrototypeOf(SymbolPrototype, this)) throw TypeError$2("Symbol is not a constructor");
    var description = arguments.length && void 0 !== arguments[0] ? toString_1(arguments[0]) : void 0, tag = uid(description), setter = function(value) {
        this === ObjectPrototype$1 && functionCall(setter, ObjectPrototypeSymbols, value), 
        hasOwnProperty_1(this, HIDDEN) && hasOwnProperty_1(this[HIDDEN], tag) && (this[HIDDEN][tag] = !1), 
        setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    return descriptors && USE_SETTER && setSymbolDescriptor(ObjectPrototype$1, tag, {
        configurable: !0,
        set: setter
    }), wrap(tag, description);
}).prototype, defineBuiltIn(SymbolPrototype, "toString", (function() {
    return getInternalState(this).tag;
})), defineBuiltIn($Symbol, "withoutSetter", (function(description) {
    return wrap(uid(description), description);
})), objectPropertyIsEnumerable.f = $propertyIsEnumerable$1, objectDefineProperty.f = $defineProperty$1, 
objectDefineProperties.f = $defineProperties, objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$2, 
objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1, 
objectGetOwnPropertySymbols.f = $getOwnPropertySymbols, wellKnownSymbolWrapped.f = function(name) {
    return wrap(wellKnownSymbol(name), name);
}, descriptors && (nativeDefineProperty(SymbolPrototype, "description", {
    configurable: !0,
    get: function() {
        return getInternalState(this).description;
    }
}), defineBuiltIn(ObjectPrototype$1, "propertyIsEnumerable", $propertyIsEnumerable$1, {
    unsafe: !0
}))), _export({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: !symbolConstructorDetection,
    sham: !symbolConstructorDetection
}, {
    Symbol: $Symbol
}), $forEach(objectKeys(WellKnownSymbolsStore$1), (function(name) {
    wellKnownSymbolDefine(name);
})), _export({
    target: "Symbol",
    stat: !0,
    forced: !symbolConstructorDetection
}, {
    useSetter: function() {
        USE_SETTER = !0;
    },
    useSimple: function() {
        USE_SETTER = !1;
    }
}), _export({
    target: "Object",
    stat: !0,
    forced: !symbolConstructorDetection,
    sham: !descriptors
}, {
    create: function(O, Properties) {
        return void 0 === Properties ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
    },
    defineProperty: $defineProperty$1,
    defineProperties: $defineProperties,
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor$2
}), _export({
    target: "Object",
    stat: !0,
    forced: !symbolConstructorDetection
}, {
    getOwnPropertyNames: $getOwnPropertyNames$1
}), function() {
    var Symbol = getBuiltIn("Symbol"), SymbolPrototype = Symbol && Symbol.prototype, valueOf = SymbolPrototype && SymbolPrototype.valueOf, TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
    SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE] && defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, (function(hint) {
        return functionCall(valueOf, this);
    }), {
        arity: 1
    });
}(), setToStringTag($Symbol, "Symbol"), hiddenKeys[HIDDEN] = !0;

var symbolRegistryDetection = symbolConstructorDetection && !!Symbol.for && !!Symbol.keyFor, StringToSymbolRegistry = shared("string-to-symbol-registry"), SymbolToStringRegistry = shared("symbol-to-string-registry");

_export({
    target: "Symbol",
    stat: !0,
    forced: !symbolRegistryDetection
}, {
    for: function(key) {
        var string = toString_1(key);
        if (hasOwnProperty_1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
        var symbol = getBuiltIn("Symbol")(string);
        return StringToSymbolRegistry[string] = symbol, SymbolToStringRegistry[symbol] = string, 
        symbol;
    }
});

var SymbolToStringRegistry$1 = shared("symbol-to-string-registry");

_export({
    target: "Symbol",
    stat: !0,
    forced: !symbolRegistryDetection
}, {
    keyFor: function(sym) {
        if (!isSymbol(sym)) throw TypeError(tryToString(sym) + " is not a symbol");
        if (hasOwnProperty_1(SymbolToStringRegistry$1, sym)) return SymbolToStringRegistry$1[sym];
    }
});

var arraySlice = functionUncurryThis([].slice), $stringify = getBuiltIn("JSON", "stringify"), exec$1 = functionUncurryThis(/./.exec), charAt = functionUncurryThis("".charAt), charCodeAt = functionUncurryThis("".charCodeAt), replace$1 = functionUncurryThis("".replace), numberToString = functionUncurryThis(1..toString), tester = /[\uD800-\uDFFF]/g, low = /^[\uD800-\uDBFF]$/, hi = /^[\uDC00-\uDFFF]$/, WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails((function() {
    var symbol = getBuiltIn("Symbol")();
    return "[null]" != $stringify([ symbol ]) || "{}" != $stringify({
        a: symbol
    }) || "{}" != $stringify(Object(symbol));
})), ILL_FORMED_UNICODE = fails((function() {
    return '"\\udf06\\ud834"' !== $stringify("\udf06\ud834") || '"\\udead"' !== $stringify("\udead");
})), stringifyWithSymbolsFix = function(it, replacer) {
    var args = arraySlice(arguments), $replacer = replacer;
    if ((isObject(replacer) || void 0 !== it) && !isSymbol(it)) return isArray(replacer) || (replacer = function(key, value) {
        if (isCallable($replacer) && (value = functionCall($replacer, this, key, value)), 
        !isSymbol(value)) return value;
    }), args[1] = replacer, functionApply($stringify, null, args);
}, fixIllFormed = function(match, offset, string) {
    var prev = charAt(string, offset - 1), next = charAt(string, offset + 1);
    return exec$1(low, match) && !exec$1(hi, next) || exec$1(hi, match) && !exec$1(low, prev) ? "\\u" + numberToString(charCodeAt(match, 0), 16) : match;
};

$stringify && _export({
    target: "JSON",
    stat: !0,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
}, {
    stringify: function(it, replacer, space) {
        var args = arraySlice(arguments), result = functionApply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
        return ILL_FORMED_UNICODE && "string" == typeof result ? replace$1(result, tester, fixIllFormed) : result;
    }
});

var FORCED$1 = !symbolConstructorDetection || fails((function() {
    objectGetOwnPropertySymbols.f(1);
}));

_export({
    target: "Object",
    stat: !0,
    forced: FORCED$1
}, {
    getOwnPropertySymbols: function(it) {
        var $getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
    }
});

var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f, FAILS_ON_PRIMITIVES = fails((function() {
    nativeGetOwnPropertyDescriptor$1(1);
}));

_export({
    target: "Object",
    stat: !0,
    forced: !descriptors || FAILS_ON_PRIMITIVES,
    sham: !descriptors
}, {
    getOwnPropertyDescriptor: function(it, key) {
        return nativeGetOwnPropertyDescriptor$1(toIndexedObject(it), key);
    }
});

var $location, defer, channel, port, engineIsNode = "process" == classofRaw(global_1.process), SPECIES$1 = wellKnownSymbol("species"), setSpecies = function(CONSTRUCTOR_NAME) {
    var Constructor = getBuiltIn(CONSTRUCTOR_NAME), defineProperty = objectDefineProperty.f;
    descriptors && Constructor && !Constructor[SPECIES$1] && defineProperty(Constructor, SPECIES$1, {
        configurable: !0,
        get: function() {
            return this;
        }
    });
}, $TypeError$7 = TypeError, $TypeError$8 = TypeError, SPECIES$2 = wellKnownSymbol("species"), speciesConstructor = function(O, defaultConstructor) {
    var S, C = anObject(O).constructor;
    return void 0 === C || isNullOrUndefined(S = anObject(C)[SPECIES$2]) ? defaultConstructor : function(argument) {
        if (isConstructor(argument)) return argument;
        throw $TypeError$8(tryToString(argument) + " is not a constructor");
    }(S);
}, $TypeError$9 = TypeError, validateArgumentsLength = function(passed, required) {
    if (passed < required) throw $TypeError$9("Not enough arguments");
    return passed;
}, engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent), set$1 = global_1.setImmediate, clear = global_1.clearImmediate, process$1 = global_1.process, Dispatch = global_1.Dispatch, Function$1 = global_1.Function, MessageChannel = global_1.MessageChannel, String$1 = global_1.String, counter = 0, queue = {};

try {
    $location = global_1.location;
} catch (error) {}

var run = function(id) {
    if (hasOwnProperty_1(queue, id)) {
        var fn = queue[id];
        delete queue[id], fn();
    }
}, runner = function(id) {
    return function() {
        run(id);
    };
}, listener = function(event) {
    run(event.data);
}, post = function(id) {
    global_1.postMessage(String$1(id), $location.protocol + "//" + $location.host);
};

set$1 && clear || (set$1 = function(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$1(handler), args = arraySlice(arguments, 1);
    return queue[++counter] = function() {
        functionApply(fn, void 0, args);
    }, defer(counter), counter;
}, clear = function(id) {
    delete queue[id];
}, engineIsNode ? defer = function(id) {
    process$1.nextTick(runner(id));
} : Dispatch && Dispatch.now ? defer = function(id) {
    Dispatch.now(runner(id));
} : MessageChannel && !engineIsIos ? (port = (channel = new MessageChannel).port2, 
channel.port1.onmessage = listener, defer = functionBindContext(port.postMessage, port)) : global_1.addEventListener && isCallable(global_1.postMessage) && !global_1.importScripts && $location && "file:" !== $location.protocol && !fails(post) ? (defer = post, 
global_1.addEventListener("message", listener, !1)) : defer = "onreadystatechange" in documentCreateElement("script") ? function(id) {
    html.appendChild(documentCreateElement("script")).onreadystatechange = function() {
        html.removeChild(this), run(id);
    };
} : function(id) {
    setTimeout(runner(id), 0);
});

var flush, head, last, notify, toggle, node, promise, then, task = {
    set: set$1,
    clear: clear
}, engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && void 0 !== global_1.Pebble, engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent), getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f, macrotask = task.set, MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver, document$2 = global_1.document, process$2 = global_1.process, Promise = global_1.Promise, queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, "queueMicrotask"), queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

queueMicrotask || (flush = function() {
    var parent, fn;
    for (engineIsNode && (parent = process$2.domain) && parent.exit(); head; ) {
        fn = head.fn, head = head.next;
        try {
            fn();
        } catch (error) {
            throw head ? notify() : last = void 0, error;
        }
    }
    last = void 0, parent && parent.enter();
}, engineIsIos || engineIsNode || engineIsWebosWebkit || !MutationObserver || !document$2 ? !engineIsIosPebble && Promise && Promise.resolve ? ((promise = Promise.resolve(void 0)).constructor = Promise, 
then = functionBindContext(promise.then, promise), notify = function() {
    then(flush);
}) : engineIsNode ? notify = function() {
    process$2.nextTick(flush);
} : (macrotask = functionBindContext(macrotask, global_1), notify = function() {
    macrotask(flush);
}) : (toggle = !0, node = document$2.createTextNode(""), new MutationObserver(flush).observe(node, {
    characterData: !0
}), notify = function() {
    node.data = toggle = !toggle;
}));

var microtask = queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: void 0
    };
    last && (last.next = task), head || (head = task, notify()), last = task;
}, perform = function(exec) {
    try {
        return {
            error: !1,
            value: exec()
        };
    } catch (error) {
        return {
            error: !0,
            value: error
        };
    }
}, Queue = function() {
    this.head = null, this.tail = null;
};

Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        this.head ? this.tail.next = entry : this.head = entry, this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) return this.head = entry.next, this.tail === entry && (this.tail = null), 
        entry.item;
    }
};

var Internal, OwnPromiseCapability, nativeThen, queue$1 = Queue, promiseNativeConstructor = global_1.Promise, engineIsDeno = "object" == typeof Deno && Deno && "object" == typeof Deno.version, engineIsBrowser = !engineIsDeno && !engineIsNode && "object" == typeof window && "object" == typeof document, SPECIES$3 = (promiseNativeConstructor && promiseNativeConstructor.prototype, 
wellKnownSymbol("species")), SUBCLASSING = !1, NATIVE_PROMISE_REJECTION_EVENT = isCallable(global_1.PromiseRejectionEvent), promiseConstructorDetection = {
    CONSTRUCTOR: isForced_1("Promise", (function() {
        var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor), GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor);
        if (!GLOBAL_CORE_JS_PROMISE && 66 === engineV8Version) return !0;
        if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
            var promise = new promiseNativeConstructor((function(resolve) {
                resolve(1);
            })), FakePromise = function(exec) {
                exec((function() {}), (function() {}));
            };
            if ((promise.constructor = {})[SPECIES$3] = FakePromise, !(SUBCLASSING = promise.then((function() {})) instanceof FakePromise)) return !0;
        }
        return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT;
    })),
    REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: SUBCLASSING
}, $TypeError$a = TypeError, PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C((function($$resolve, $$reject) {
        if (void 0 !== resolve || void 0 !== reject) throw $TypeError$a("Bad Promise constructor");
        resolve = $$resolve, reject = $$reject;
    })), this.resolve = aCallable(resolve), this.reject = aCallable(reject);
}, newPromiseCapability = {
    f: function(C) {
        return new PromiseCapability(C);
    }
}, task$1 = task.set, FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR, NATIVE_PROMISE_REJECTION_EVENT$1 = promiseConstructorDetection.REJECTION_EVENT, NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING, getInternalPromiseState = internalState.getterFor("Promise"), setInternalState$1 = internalState.set, NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype, PromiseConstructor = promiseNativeConstructor, PromisePrototype = NativePromisePrototype$1, TypeError$3 = global_1.TypeError, document$3 = global_1.document, process$3 = global_1.process, newPromiseCapability$1 = newPromiseCapability.f, newGenericPromiseCapability = newPromiseCapability$1, DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global_1.dispatchEvent), isThenable = function(it) {
    var then;
    return !(!isObject(it) || !isCallable(then = it.then)) && then;
}, callReaction = function(reaction, state) {
    var result, then, exited, value = state.value, ok = 1 == state.state, handler = ok ? reaction.ok : reaction.fail, resolve = reaction.resolve, reject = reaction.reject, domain = reaction.domain;
    try {
        handler ? (ok || (2 === state.rejection && onHandleUnhandled(state), state.rejection = 1), 
        !0 === handler ? result = value : (domain && domain.enter(), result = handler(value), 
        domain && (domain.exit(), exited = !0)), result === reaction.promise ? reject(TypeError$3("Promise-chain cycle")) : (then = isThenable(result)) ? functionCall(then, result, resolve, reject) : resolve(result)) : reject(value);
    } catch (error) {
        domain && !exited && domain.exit(), reject(error);
    }
}, notify$1 = function(state, isReject) {
    state.notified || (state.notified = !0, microtask((function() {
        for (var reaction, reactions = state.reactions; reaction = reactions.get(); ) callReaction(reaction, state);
        state.notified = !1, isReject && !state.rejection && onUnhandled(state);
    })));
}, dispatchEvent = function(name, promise, reason) {
    var event, handler;
    DISPATCH_EVENT ? ((event = document$3.createEvent("Event")).promise = promise, event.reason = reason, 
    event.initEvent(name, !1, !0), global_1.dispatchEvent(event)) : event = {
        promise: promise,
        reason: reason
    }, !NATIVE_PROMISE_REJECTION_EVENT$1 && (handler = global_1["on" + name]) ? handler(event) : "unhandledrejection" === name && function(a, b) {
        var console = global_1.console;
        console && console.error && (1 == arguments.length ? console.error(a) : console.error(a, b));
    }("Unhandled promise rejection", reason);
}, onUnhandled = function(state) {
    functionCall(task$1, global_1, (function() {
        var result, promise = state.facade, value = state.value;
        if (isUnhandled(state) && (result = perform((function() {
            engineIsNode ? process$3.emit("unhandledRejection", value, promise) : dispatchEvent("unhandledrejection", promise, value);
        })), state.rejection = engineIsNode || isUnhandled(state) ? 2 : 1, result.error)) throw result.value;
    }));
}, isUnhandled = function(state) {
    return 1 !== state.rejection && !state.parent;
}, onHandleUnhandled = function(state) {
    functionCall(task$1, global_1, (function() {
        var promise = state.facade;
        engineIsNode ? process$3.emit("rejectionHandled", promise) : dispatchEvent("rejectionhandled", promise, state.value);
    }));
}, bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
}, internalReject = function(state, value, unwrap) {
    state.done || (state.done = !0, unwrap && (state = unwrap), state.value = value, 
    state.state = 2, notify$1(state, !0));
}, internalResolve = function(state, value, unwrap) {
    if (!state.done) {
        state.done = !0, unwrap && (state = unwrap);
        try {
            if (state.facade === value) throw TypeError$3("Promise can't be resolved itself");
            var then = isThenable(value);
            then ? microtask((function() {
                var wrapper = {
                    done: !1
                };
                try {
                    functionCall(then, value, bind$1(internalResolve, wrapper, state), bind$1(internalReject, wrapper, state));
                } catch (error) {
                    internalReject(wrapper, error, state);
                }
            })) : (state.value = value, state.state = 1, notify$1(state, !1));
        } catch (error) {
            internalReject({
                done: !1
            }, error, state);
        }
    }
};

if (FORCED_PROMISE_CONSTRUCTOR$1 && (PromisePrototype = (PromiseConstructor = function(executor) {
    !function(it, Prototype) {
        if (objectIsPrototypeOf(Prototype, it)) return it;
        throw $TypeError$7("Incorrect invocation");
    }(this, PromisePrototype), aCallable(executor), functionCall(Internal, this);
    var state = getInternalPromiseState(this);
    try {
        executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
        internalReject(state, error);
    }
}).prototype, (Internal = function(executor) {
    setInternalState$1(this, {
        type: "Promise",
        done: !1,
        notified: !1,
        parent: !1,
        reactions: new queue$1,
        rejection: !1,
        state: 0,
        value: void 0
    });
}).prototype = defineBuiltIn(PromisePrototype, "then", (function(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this), reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    return state.parent = !0, reaction.ok = !isCallable(onFulfilled) || onFulfilled, 
    reaction.fail = isCallable(onRejected) && onRejected, reaction.domain = engineIsNode ? process$3.domain : void 0, 
    0 == state.state ? state.reactions.add(reaction) : microtask((function() {
        callReaction(reaction, state);
    })), reaction.promise;
})), OwnPromiseCapability = function() {
    var promise = new Internal, state = getInternalPromiseState(promise);
    this.promise = promise, this.resolve = bind$1(internalResolve, state), this.reject = bind$1(internalReject, state);
}, newPromiseCapability.f = newPromiseCapability$1 = function(C) {
    return C === PromiseConstructor || void 0 === C ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
}, isCallable(promiseNativeConstructor) && NativePromisePrototype$1 !== Object.prototype)) {
    nativeThen = NativePromisePrototype$1.then, NATIVE_PROMISE_SUBCLASSING || defineBuiltIn(NativePromisePrototype$1, "then", (function(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor((function(resolve, reject) {
            functionCall(nativeThen, that, resolve, reject);
        })).then(onFulfilled, onRejected);
    }), {
        unsafe: !0
    });
    try {
        delete NativePromisePrototype$1.constructor;
    } catch (error) {}
    objectSetPrototypeOf && objectSetPrototypeOf(NativePromisePrototype$1, PromisePrototype);
}

_export({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: FORCED_PROMISE_CONSTRUCTOR$1
}, {
    Promise: PromiseConstructor
}), setToStringTag(PromiseConstructor, "Promise", !1), setSpecies("Promise");

var iterators = {}, ITERATOR = wellKnownSymbol("iterator"), ArrayPrototype = Array.prototype, ITERATOR$1 = wellKnownSymbol("iterator"), getIteratorMethod = function(it) {
    if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$1) || getMethod(it, "@@iterator") || iterators[classof(it)];
}, $TypeError$b = TypeError, iteratorClose = function(iterator, kind, value) {
    var innerResult, innerError;
    anObject(iterator);
    try {
        if (!(innerResult = getMethod(iterator, "return"))) {
            if ("throw" === kind) throw value;
            return value;
        }
        innerResult = functionCall(innerResult, iterator);
    } catch (error) {
        innerError = !0, innerResult = error;
    }
    if ("throw" === kind) throw value;
    if (innerError) throw innerResult;
    return anObject(innerResult), value;
}, $TypeError$c = TypeError, Result = function(stopped, result) {
    this.stopped = stopped, this.result = result;
}, ResultPrototype = Result.prototype, iterate = function(iterable, unboundFunction, options) {
    var iterator, iterFn, index, length, result, next, step, it, that = options && options.that, AS_ENTRIES = !(!options || !options.AS_ENTRIES), IS_RECORD = !(!options || !options.IS_RECORD), IS_ITERATOR = !(!options || !options.IS_ITERATOR), INTERRUPTED = !(!options || !options.INTERRUPTED), fn = functionBindContext(unboundFunction, that), stop = function(condition) {
        return iterator && iteratorClose(iterator, "normal", condition), new Result(!0, condition);
    }, callFn = function(value) {
        return AS_ENTRIES ? (anObject(value), INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1])) : INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator; else if (IS_ITERATOR) iterator = iterable; else {
        if (!(iterFn = getIteratorMethod(iterable))) throw $TypeError$c(tryToString(iterable) + " is not iterable");
        if (void 0 !== (it = iterFn) && (iterators.Array === it || ArrayPrototype[ITERATOR] === it)) {
            for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) if ((result = callFn(iterable[index])) && objectIsPrototypeOf(ResultPrototype, result)) return result;
            return new Result(!1);
        }
        iterator = function(argument, usingIterator) {
            var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
            if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
            throw $TypeError$b(tryToString(argument) + " is not iterable");
        }(iterable, iterFn);
    }
    for (next = IS_RECORD ? iterable.next : iterator.next; !(step = functionCall(next, iterator)).done; ) {
        try {
            result = callFn(step.value);
        } catch (error) {
            iteratorClose(iterator, "throw", error);
        }
        if ("object" == typeof result && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
    }
    return new Result(!1);
}, ITERATOR$2 = wellKnownSymbol("iterator"), SAFE_CLOSING = !1;

try {
    var called = 0, iteratorWithReturn = {
        next: function() {
            return {
                done: !!called++
            };
        },
        return: function() {
            SAFE_CLOSING = !0;
        }
    };
    iteratorWithReturn[ITERATOR$2] = function() {
        return this;
    }, Array.from(iteratorWithReturn, (function() {
        throw 2;
    }));
} catch (error) {}

var promiseStaticsIncorrectIteration = promiseConstructorDetection.CONSTRUCTOR || !function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return !1;
    var ITERATION_SUPPORT = !1;
    try {
        var object = {};
        object[ITERATOR$2] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = !0
                    };
                }
            };
        }, exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
}((function(iterable) {
    promiseNativeConstructor.all(iterable).then(void 0, (function() {}));
}));

_export({
    target: "Promise",
    stat: !0,
    forced: promiseStaticsIncorrectIteration
}, {
    all: function(iterable) {
        var C = this, capability = newPromiseCapability.f(C), resolve = capability.resolve, reject = capability.reject, result = perform((function() {
            var $promiseResolve = aCallable(C.resolve), values = [], counter = 0, remaining = 1;
            iterate(iterable, (function(promise) {
                var index = counter++, alreadyCalled = !1;
                remaining++, functionCall($promiseResolve, C, promise).then((function(value) {
                    alreadyCalled || (alreadyCalled = !0, values[index] = value, --remaining || resolve(values));
                }), reject);
            })), --remaining || resolve(values);
        }));
        return result.error && reject(result.value), capability.promise;
    }
});

var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR, NativePromisePrototype$2 = promiseNativeConstructor && promiseNativeConstructor.prototype;

if (_export({
    target: "Promise",
    proto: !0,
    forced: FORCED_PROMISE_CONSTRUCTOR$3,
    real: !0
}, {
    catch: function(onRejected) {
        return this.then(void 0, onRejected);
    }
}), isCallable(promiseNativeConstructor)) {
    var method = getBuiltIn("Promise").prototype.catch;
    NativePromisePrototype$2.catch !== method && defineBuiltIn(NativePromisePrototype$2, "catch", method, {
        unsafe: !0
    });
}

_export({
    target: "Promise",
    stat: !0,
    forced: promiseStaticsIncorrectIteration
}, {
    race: function(iterable) {
        var C = this, capability = newPromiseCapability.f(C), reject = capability.reject, result = perform((function() {
            var $promiseResolve = aCallable(C.resolve);
            iterate(iterable, (function(promise) {
                functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
            }));
        }));
        return result.error && reject(result.value), capability.promise;
    }
}), _export({
    target: "Promise",
    stat: !0,
    forced: promiseConstructorDetection.CONSTRUCTOR
}, {
    reject: function(r) {
        var capability = newPromiseCapability.f(this);
        return functionCall(capability.reject, void 0, r), capability.promise;
    }
});

var FORCED_PROMISE_CONSTRUCTOR$5 = promiseConstructorDetection.CONSTRUCTOR;

getBuiltIn("Promise");

_export({
    target: "Promise",
    stat: !0,
    forced: FORCED_PROMISE_CONSTRUCTOR$5
}, {
    resolve: function(x) {
        return function(C, x) {
            if (anObject(C), isObject(x) && x.constructor === C) return x;
            var promiseCapability = newPromiseCapability.f(C);
            return (0, promiseCapability.resolve)(x), promiseCapability.promise;
        }(this, x);
    }
});

var defineProperty$5 = objectDefineProperty.f, NativeSymbol = global_1.Symbol, SymbolPrototype$1 = NativeSymbol && NativeSymbol.prototype;

if (descriptors && isCallable(NativeSymbol) && (!("description" in SymbolPrototype$1) || void 0 !== NativeSymbol().description)) {
    var EmptyStringDescriptionStore = {}, SymbolWrapper = function() {
        var description = arguments.length < 1 || void 0 === arguments[0] ? void 0 : toString_1(arguments[0]), result = objectIsPrototypeOf(SymbolPrototype$1, this) ? new NativeSymbol(description) : void 0 === description ? NativeSymbol() : NativeSymbol(description);
        return "" === description && (EmptyStringDescriptionStore[result] = !0), result;
    };
    copyConstructorProperties(SymbolWrapper, NativeSymbol), SymbolWrapper.prototype = SymbolPrototype$1, 
    SymbolPrototype$1.constructor = SymbolWrapper;
    var NATIVE_SYMBOL = "Symbol(test)" == String(NativeSymbol("test")), thisSymbolValue = functionUncurryThis(SymbolPrototype$1.valueOf), symbolDescriptiveString = functionUncurryThis(SymbolPrototype$1.toString), regexp = /^Symbol\((.*)\)[^)]+$/, replace$2 = functionUncurryThis("".replace), stringSlice$1 = functionUncurryThis("".slice);
    defineProperty$5(SymbolPrototype$1, "description", {
        configurable: !0,
        get: function() {
            var symbol = thisSymbolValue(this);
            if (hasOwnProperty_1(EmptyStringDescriptionStore, symbol)) return "";
            var string = symbolDescriptiveString(symbol), desc = NATIVE_SYMBOL ? stringSlice$1(string, 7, -1) : replace$2(string, regexp, "$1");
            return "" === desc ? void 0 : desc;
        }
    }), _export({
        global: !0,
        constructor: !0,
        forced: !0
    }, {
        Symbol: SymbolWrapper
    });
}

wellKnownSymbolDefine("iterator");

var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator, charAt$1 = functionUncurryThis("".charAt), charCodeAt$1 = functionUncurryThis("".charCodeAt), stringSlice$2 = functionUncurryThis("".slice), createMethod$2 = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var first, second, S = toString_1(requireObjectCoercible($this)), position = toIntegerOrInfinity(pos), size = S.length;
        return position < 0 || position >= size ? CONVERT_TO_STRING ? "" : void 0 : (first = charCodeAt$1(S, position)) < 55296 || first > 56319 || position + 1 === size || (second = charCodeAt$1(S, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt$1(S, position) : first : CONVERT_TO_STRING ? stringSlice$2(S, position, position + 2) : second - 56320 + (first - 55296 << 10) + 65536;
    };
}, stringMultibyte = {
    codeAt: createMethod$2(!1),
    charAt: createMethod$2(!0)
}, ITERATOR$3 = wellKnownSymbol("iterator"), BUGGY_SAFARI_ITERATORS = !1;

[].keys && ("next" in (arrayIterator = [].keys()) ? (PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator))) !== Object.prototype && (IteratorPrototype = PrototypeOfArrayIteratorPrototype) : BUGGY_SAFARI_ITERATORS = !0), 
(!isObject(IteratorPrototype) || fails((function() {
    var test = {};
    return IteratorPrototype[ITERATOR$3].call(test) !== test;
}))) && (IteratorPrototype = {}), isCallable(IteratorPrototype[ITERATOR$3]) || defineBuiltIn(IteratorPrototype, ITERATOR$3, (function() {
    return this;
}));

var iteratorsCore = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
}, IteratorPrototype$1 = iteratorsCore.IteratorPrototype, returnThis = function() {
    return this;
}, PROPER_FUNCTION_NAME = functionName.PROPER, CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE, IteratorPrototype$2 = iteratorsCore.IteratorPrototype, BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS, ITERATOR$4 = wellKnownSymbol("iterator"), returnThis$1 = function() {
    return this;
}, iteratorDefine = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    !function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
        var TO_STRING_TAG = NAME + " Iterator";
        IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
            next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
        }), setToStringTag(IteratorConstructor, TO_STRING_TAG, !1), iterators[TO_STRING_TAG] = returnThis;
    }(IteratorConstructor, NAME, next);
    var CurrentIteratorPrototype, methods, KEY, getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch (KIND) {
          case "keys":
          case "values":
          case "entries":
            return function() {
                return new IteratorConstructor(this, KIND);
            };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    }, TO_STRING_TAG = NAME + " Iterator", INCORRECT_VALUES_NAME = !1, IterablePrototype = Iterable.prototype, nativeIterator = IterablePrototype[ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT], defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT), anyNativeIterator = "Array" == NAME && IterablePrototype.entries || nativeIterator;
    if (anyNativeIterator && (CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable))) !== Object.prototype && CurrentIteratorPrototype.next && (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2 && (objectSetPrototypeOf ? objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2) : isCallable(CurrentIteratorPrototype[ITERATOR$4]) || defineBuiltIn(CurrentIteratorPrototype, ITERATOR$4, returnThis$1)), 
    setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, !0)), PROPER_FUNCTION_NAME && "values" == DEFAULT && nativeIterator && "values" !== nativeIterator.name && (CONFIGURABLE_FUNCTION_NAME ? createNonEnumerableProperty(IterablePrototype, "name", "values") : (INCORRECT_VALUES_NAME = !0, 
    defaultIterator = function() {
        return functionCall(nativeIterator, this);
    })), DEFAULT) if (methods = {
        values: getIterationMethod("values"),
        keys: IS_SET ? defaultIterator : getIterationMethod("keys"),
        entries: getIterationMethod("entries")
    }, FORCED) for (KEY in methods) (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) && defineBuiltIn(IterablePrototype, KEY, methods[KEY]); else _export({
        target: NAME,
        proto: !0,
        forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
    }, methods);
    return IterablePrototype[ITERATOR$4] !== defaultIterator && defineBuiltIn(IterablePrototype, ITERATOR$4, defaultIterator, {
        name: DEFAULT
    }), iterators[NAME] = defaultIterator, methods;
}, createIterResultObject = function(value, done) {
    return {
        value: value,
        done: done
    };
}, charAt$2 = stringMultibyte.charAt, setInternalState$2 = internalState.set, getInternalState$1 = internalState.getterFor("String Iterator");

iteratorDefine(String, "String", (function(iterated) {
    setInternalState$2(this, {
        type: "String Iterator",
        string: toString_1(iterated),
        index: 0
    });
}), (function() {
    var point, state = getInternalState$1(this), string = state.string, index = state.index;
    return index >= string.length ? createIterResultObject(void 0, !0) : (point = charAt$2(string, index), 
    state.index += point.length, createIterResultObject(point, !1));
}));

var defineProperty$6 = objectDefineProperty.f, UNSCOPABLES = wellKnownSymbol("unscopables"), ArrayPrototype$1 = Array.prototype;

null == ArrayPrototype$1[UNSCOPABLES] && defineProperty$6(ArrayPrototype$1, UNSCOPABLES, {
    configurable: !0,
    value: objectCreate(null)
});

var addToUnscopables = function(key) {
    ArrayPrototype$1[UNSCOPABLES][key] = !0;
}, defineProperty$7 = objectDefineProperty.f, setInternalState$3 = internalState.set, getInternalState$2 = internalState.getterFor("Array Iterator"), es_array_iterator = iteratorDefine(Array, "Array", (function(iterated, kind) {
    setInternalState$3(this, {
        type: "Array Iterator",
        target: toIndexedObject(iterated),
        index: 0,
        kind: kind
    });
}), (function() {
    var state = getInternalState$2(this), target = state.target, kind = state.kind, index = state.index++;
    return !target || index >= target.length ? (state.target = void 0, createIterResultObject(void 0, !0)) : createIterResultObject("keys" == kind ? index : "values" == kind ? target[index] : [ index, target[index] ], !1);
}), "values"), values = iterators.Arguments = iterators.Array;

if (addToUnscopables("keys"), addToUnscopables("values"), addToUnscopables("entries"), 
descriptors && "values" !== values.name) try {
    defineProperty$7(values, "name", {
        value: "values"
    });
} catch (error) {}

var domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
}, classList = documentCreateElement("span").classList, DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype, domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? void 0 : DOMTokenListPrototype, ITERATOR$5 = wellKnownSymbol("iterator"), TO_STRING_TAG$3 = wellKnownSymbol("toStringTag"), ArrayValues = es_array_iterator.values, handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        if (CollectionPrototype[ITERATOR$5] !== ArrayValues) try {
            createNonEnumerableProperty(CollectionPrototype, ITERATOR$5, ArrayValues);
        } catch (error) {
            CollectionPrototype[ITERATOR$5] = ArrayValues;
        }
        if (CollectionPrototype[TO_STRING_TAG$3] || createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME), 
        domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
            createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
        } catch (error) {
            CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
        }
    }
};

for (var COLLECTION_NAME in domIterables) handlePrototype(global_1[COLLECTION_NAME] && global_1[COLLECTION_NAME].prototype, COLLECTION_NAME);

handlePrototype(domTokenListPrototype, "DOMTokenList");

var $TypeError$d = TypeError, doesNotExceedSafeInteger = function(it) {
    if (it > 9007199254740991) throw $TypeError$d("Maximum allowed index exceeded");
    return it;
}, SPECIES$4 = wellKnownSymbol("species"), arrayMethodHasSpeciesSupport = function(METHOD_NAME) {
    return engineV8Version >= 51 || !fails((function() {
        var array = [];
        return (array.constructor = {})[SPECIES$4] = function() {
            return {
                foo: 1
            };
        }, 1 !== array[METHOD_NAME](Boolean).foo;
    }));
}, IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable"), IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails((function() {
    var array = [];
    return array[IS_CONCAT_SPREADABLE] = !1, array.concat()[0] !== array;
})), SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat"), isConcatSpreadable = function(O) {
    if (!isObject(O)) return !1;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return void 0 !== spreadable ? !!spreadable : isArray(O);
};

_export({
    target: "Array",
    proto: !0,
    arity: 1,
    forced: !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT
}, {
    concat: function(arg) {
        var i, k, length, len, E, O = toObject(this), A = arraySpeciesCreate(O, 0), n = 0;
        for (i = -1, length = arguments.length; i < length; i++) if (isConcatSpreadable(E = -1 === i ? O : arguments[i])) for (len = lengthOfArrayLike(E), 
        doesNotExceedSafeInteger(n + len), k = 0; k < len; k++, n++) k in E && createProperty(A, n, E[k]); else doesNotExceedSafeInteger(n + 1), 
        createProperty(A, n++, E);
        return A.length = n, A;
    }
});

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice"), SPECIES$5 = wellKnownSymbol("species"), $Array$2 = Array, max$2 = Math.max;

_export({
    target: "Array",
    proto: !0,
    forced: !HAS_SPECIES_SUPPORT
}, {
    slice: function(start, end) {
        var Constructor, result, n, O = toIndexedObject(this), length = lengthOfArrayLike(O), k = toAbsoluteIndex(start, length), fin = toAbsoluteIndex(void 0 === end ? length : end, length);
        if (isArray(O) && (Constructor = O.constructor, (isConstructor(Constructor) && (Constructor === $Array$2 || isArray(Constructor.prototype)) || isObject(Constructor) && null === (Constructor = Constructor[SPECIES$5])) && (Constructor = void 0), 
        Constructor === $Array$2 || void 0 === Constructor)) return arraySlice(O, k, fin);
        for (result = new (void 0 === Constructor ? $Array$2 : Constructor)(max$2(fin - k, 0)), 
        n = 0; k < fin; k++, n++) k in O && createProperty(result, n, O[k]);
        return result.length = n, result;
    }
}), wellKnownSymbolDefine("asyncIterator");

var __assign = function() {
    return (__assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) for (var p in s = arguments[i]) Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
        return t;
    }).apply(this, arguments);
}, regexpFlags = function() {
    var that = anObject(this), result = "";
    return that.hasIndices && (result += "d"), that.global && (result += "g"), that.ignoreCase && (result += "i"), 
    that.multiline && (result += "m"), that.dotAll && (result += "s"), that.unicode && (result += "u"), 
    that.unicodeSets && (result += "v"), that.sticky && (result += "y"), result;
}, $RegExp = global_1.RegExp, UNSUPPORTED_Y = fails((function() {
    var re = $RegExp("a", "y");
    return re.lastIndex = 2, null != re.exec("abcd");
})), MISSED_STICKY = UNSUPPORTED_Y || fails((function() {
    return !$RegExp("a", "y").sticky;
})), regexpStickyHelpers = {
    BROKEN_CARET: UNSUPPORTED_Y || fails((function() {
        var re = $RegExp("^r", "gy");
        return re.lastIndex = 2, null != re.exec("str");
    })),
    MISSED_STICKY: MISSED_STICKY,
    UNSUPPORTED_Y: UNSUPPORTED_Y
}, $RegExp$1 = global_1.RegExp, regexpUnsupportedDotAll = fails((function() {
    var re = $RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && "s" === re.flags);
})), $RegExp$2 = global_1.RegExp, regexpUnsupportedNcg = fails((function() {
    var re = $RegExp$2("(?<a>b)", "g");
    return "b" !== re.exec("b").groups.a || "bc" !== "b".replace(re, "$<a>c");
})), getInternalState$3 = internalState.get, nativeReplace = shared("native-string-replace", String.prototype.replace), nativeExec = RegExp.prototype.exec, patchedExec = nativeExec, charAt$3 = functionUncurryThis("".charAt), indexOf$1 = functionUncurryThis("".indexOf), replace$3 = functionUncurryThis("".replace), stringSlice$3 = functionUncurryThis("".slice), UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/, re2 = /b*/g;
    return functionCall(nativeExec, re1, "a"), functionCall(nativeExec, re2, "a"), 0 !== re1.lastIndex || 0 !== re2.lastIndex;
}(), UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET, NPCG_INCLUDED = void 0 !== /()??/.exec("")[1];

(UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg) && (patchedExec = function(string) {
    var result, reCopy, lastIndex, match, i, object, group, re = this, state = getInternalState$3(re), str = toString_1(string), raw = state.raw;
    if (raw) return raw.lastIndex = re.lastIndex, result = functionCall(patchedExec, raw, str), 
    re.lastIndex = raw.lastIndex, result;
    var groups = state.groups, sticky = UNSUPPORTED_Y$1 && re.sticky, flags = functionCall(regexpFlags, re), source = re.source, charsAdded = 0, strCopy = str;
    if (sticky && (flags = replace$3(flags, "y", ""), -1 === indexOf$1(flags, "g") && (flags += "g"), 
    strCopy = stringSlice$3(str, re.lastIndex), re.lastIndex > 0 && (!re.multiline || re.multiline && "\n" !== charAt$3(str, re.lastIndex - 1)) && (source = "(?: " + source + ")", 
    strCopy = " " + strCopy, charsAdded++), reCopy = new RegExp("^(?:" + source + ")", flags)), 
    NPCG_INCLUDED && (reCopy = new RegExp("^" + source + "$(?!\\s)", flags)), UPDATES_LAST_INDEX_WRONG && (lastIndex = re.lastIndex), 
    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy), sticky ? match ? (match.input = stringSlice$3(match.input, charsAdded), 
    match[0] = stringSlice$3(match[0], charsAdded), match.index = re.lastIndex, re.lastIndex += match[0].length) : re.lastIndex = 0 : UPDATES_LAST_INDEX_WRONG && match && (re.lastIndex = re.global ? match.index + match[0].length : lastIndex), 
    NPCG_INCLUDED && match && match.length > 1 && functionCall(nativeReplace, match[0], reCopy, (function() {
        for (i = 1; i < arguments.length - 2; i++) void 0 === arguments[i] && (match[i] = void 0);
    })), match && groups) for (match.groups = object = objectCreate(null), i = 0; i < groups.length; i++) object[(group = groups[i])[0]] = match[group[1]];
    return match;
});

var regexpExec = patchedExec;

_export({
    target: "RegExp",
    proto: !0,
    forced: /./.exec !== regexpExec
}, {
    exec: regexpExec
});

var execCalled, re, DELEGATES_TO_EXEC = (execCalled = !1, (re = /[ac]/).exec = function() {
    return execCalled = !0, /./.exec.apply(this, arguments);
}, !0 === re.test("abc") && execCalled), nativeTest = /./.test;

_export({
    target: "RegExp",
    proto: !0,
    forced: !DELEGATES_TO_EXEC
}, {
    test: function(S) {
        var R = anObject(this), string = toString_1(S), exec = R.exec;
        if (!isCallable(exec)) return functionCall(nativeTest, R, string);
        var result = functionCall(exec, R, string);
        return null !== result && (anObject(result), !0);
    }
});

var MATCH = wellKnownSymbol("match"), isRegexp = function(it) {
    var isRegExp;
    return isObject(it) && (void 0 !== (isRegExp = it[MATCH]) ? !!isRegExp : "RegExp" == classofRaw(it));
}, RegExpPrototype = RegExp.prototype, regexpGetFlags = function(R) {
    var flags = R.flags;
    return void 0 !== flags || "flags" in RegExpPrototype || hasOwnProperty_1(R, "flags") || !objectIsPrototypeOf(RegExpPrototype, R) ? flags : functionCall(regexpFlags, R);
}, getOwnPropertyNames = objectGetOwnPropertyNames.f, enforceInternalState = internalState.enforce, MATCH$1 = wellKnownSymbol("match"), NativeRegExp = global_1.RegExp, RegExpPrototype$1 = NativeRegExp.prototype, SyntaxError = global_1.SyntaxError, exec$2 = functionUncurryThis(RegExpPrototype$1.exec), charAt$4 = functionUncurryThis("".charAt), replace$4 = functionUncurryThis("".replace), stringIndexOf = functionUncurryThis("".indexOf), stringSlice$4 = functionUncurryThis("".slice), IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, re1 = /a/g, re2 = /a/g, CORRECT_NEW = new NativeRegExp(re1) !== re1, MISSED_STICKY$1 = regexpStickyHelpers.MISSED_STICKY, UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y, BASE_FORCED = descriptors && (!CORRECT_NEW || MISSED_STICKY$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg || fails((function() {
    return re2[MATCH$1] = !1, NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || "/a/i" != NativeRegExp(re1, "i");
})));

if (isForced_1("RegExp", BASE_FORCED)) {
    for (var RegExpWrapper = function(pattern, flags) {
        var rawFlags, dotAll, sticky, handled, result, state, thisIsRegExp = objectIsPrototypeOf(RegExpPrototype$1, this), patternIsRegExp = isRegexp(pattern), flagsAreUndefined = void 0 === flags, groups = [], rawPattern = pattern;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) return pattern;
        if ((patternIsRegExp || objectIsPrototypeOf(RegExpPrototype$1, pattern)) && (pattern = pattern.source, 
        flagsAreUndefined && (flags = regexpGetFlags(rawPattern))), pattern = void 0 === pattern ? "" : toString_1(pattern), 
        flags = void 0 === flags ? "" : toString_1(flags), rawPattern = pattern, regexpUnsupportedDotAll && "dotAll" in re1 && (dotAll = !!flags && stringIndexOf(flags, "s") > -1) && (flags = replace$4(flags, /s/g, "")), 
        rawFlags = flags, MISSED_STICKY$1 && "sticky" in re1 && (sticky = !!flags && stringIndexOf(flags, "y") > -1) && UNSUPPORTED_Y$2 && (flags = replace$4(flags, /y/g, "")), 
        regexpUnsupportedNcg && (pattern = (handled = function(string) {
            for (var chr, length = string.length, index = 0, result = "", named = [], names = {}, brackets = !1, ncg = !1, groupid = 0, groupname = ""; index <= length; index++) {
                if ("\\" === (chr = charAt$4(string, index))) chr += charAt$4(string, ++index); else if ("]" === chr) brackets = !1; else if (!brackets) switch (!0) {
                  case "[" === chr:
                    brackets = !0;
                    break;

                  case "(" === chr:
                    exec$2(IS_NCG, stringSlice$4(string, index + 1)) && (index += 2, ncg = !0), result += chr, 
                    groupid++;
                    continue;

                  case ">" === chr && ncg:
                    if ("" === groupname || hasOwnProperty_1(names, groupname)) throw new SyntaxError("Invalid capture group name");
                    names[groupname] = !0, named[named.length] = [ groupname, groupid ], ncg = !1, groupname = "";
                    continue;
                }
                ncg ? groupname += chr : result += chr;
            }
            return [ result, named ];
        }(pattern))[0], groups = handled[1]), result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$1, RegExpWrapper), 
        (dotAll || sticky || groups.length) && (state = enforceInternalState(result), dotAll && (state.dotAll = !0, 
        state.raw = RegExpWrapper(function(string) {
            for (var chr, length = string.length, index = 0, result = "", brackets = !1; index <= length; index++) "\\" !== (chr = charAt$4(string, index)) ? brackets || "." !== chr ? ("[" === chr ? brackets = !0 : "]" === chr && (brackets = !1), 
            result += chr) : result += "[\\s\\S]" : result += chr + charAt$4(string, ++index);
            return result;
        }(pattern), rawFlags)), sticky && (state.sticky = !0), groups.length && (state.groups = groups)), 
        pattern !== rawPattern) try {
            createNonEnumerableProperty(result, "source", "" === rawPattern ? "(?:)" : rawPattern);
        } catch (error) {}
        return result;
    }, keys$1 = getOwnPropertyNames(NativeRegExp), index = 0; keys$1.length > index; ) proxyAccessor(RegExpWrapper, NativeRegExp, keys$1[index++]);
    RegExpPrototype$1.constructor = RegExpWrapper, RegExpWrapper.prototype = RegExpPrototype$1, 
    defineBuiltIn(global_1, "RegExp", RegExpWrapper, {
        constructor: !0
    });
}

setSpecies("RegExp");

var PROPER_FUNCTION_NAME$1 = functionName.PROPER, nativeToString = RegExp.prototype.toString, NOT_GENERIC = fails((function() {
    return "/a/b" != nativeToString.call({
        source: "a",
        flags: "b"
    });
})), INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && "toString" != nativeToString.name;

(NOT_GENERIC || INCORRECT_NAME) && defineBuiltIn(RegExp.prototype, "toString", (function() {
    var R = anObject(this);
    return "/" + toString_1(R.source) + "/" + toString_1(regexpGetFlags(R));
}), {
    unsafe: !0
});

var SPECIES$6 = wellKnownSymbol("species"), RegExpPrototype$3 = RegExp.prototype, fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = wellKnownSymbol(KEY), DELEGATES_TO_SYMBOL = !fails((function() {
        var O = {};
        return O[SYMBOL] = function() {
            return 7;
        }, 7 != ""[KEY](O);
    })), DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails((function() {
        var execCalled = !1, re = /a/;
        return "split" === KEY && ((re = {}).constructor = {}, re.constructor[SPECIES$6] = function() {
            return re;
        }, re.flags = "", re[SYMBOL] = /./[SYMBOL]), re.exec = function() {
            return execCalled = !0, null;
        }, re[SYMBOL](""), !execCalled;
    }));
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = functionUncurryThisClause(/./[SYMBOL]), methods = exec(SYMBOL, ""[KEY], (function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = functionUncurryThisClause(nativeMethod), $exec = regexp.exec;
            return $exec === regexpExec || $exec === RegExpPrototype$3.exec ? DELEGATES_TO_SYMBOL && !forceStringMethod ? {
                done: !0,
                value: uncurriedNativeRegExpMethod(regexp, str, arg2)
            } : {
                done: !0,
                value: uncurriedNativeMethod(str, regexp, arg2)
            } : {
                done: !1
            };
        }));
        defineBuiltIn(String.prototype, KEY, methods[0]), defineBuiltIn(RegExpPrototype$3, SYMBOL, methods[1]);
    }
    SHAM && createNonEnumerableProperty(RegExpPrototype$3[SYMBOL], "sham", !0);
}, charAt$5 = stringMultibyte.charAt, advanceStringIndex = function(S, index, unicode) {
    return index + (unicode ? charAt$5(S, index).length : 1);
}, $TypeError$e = TypeError, regexpExecAbstract = function(R, S) {
    var exec = R.exec;
    if (isCallable(exec)) {
        var result = functionCall(exec, R, S);
        return null !== result && anObject(result), result;
    }
    if ("RegExp" === classofRaw(R)) return functionCall(regexpExec, R, S);
    throw $TypeError$e("RegExp#exec called on incompatible receiver");
}, UNSUPPORTED_Y$3 = regexpStickyHelpers.UNSUPPORTED_Y, min$2 = Math.min, $push = [].push, exec$3 = functionUncurryThis(/./.exec), push$3 = functionUncurryThis($push), stringSlice$5 = functionUncurryThis("".slice);

fixRegexpWellKnownSymbolLogic("split", (function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    return internalSplit = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(separator, limit) {
        var string = toString_1(requireObjectCoercible(this)), lim = void 0 === limit ? 4294967295 : limit >>> 0;
        if (0 === lim) return [];
        if (void 0 === separator) return [ string ];
        if (!isRegexp(separator)) return functionCall(nativeSplit, string, separator, lim);
        for (var match, lastIndex, lastLength, output = [], flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : ""), lastLastIndex = 0, separatorCopy = new RegExp(separator.source, flags + "g"); (match = functionCall(regexpExec, separatorCopy, string)) && !((lastIndex = separatorCopy.lastIndex) > lastLastIndex && (push$3(output, stringSlice$5(string, lastLastIndex, match.index)), 
        match.length > 1 && match.index < string.length && functionApply($push, output, arraySliceSimple(match, 1)), 
        lastLength = match[0].length, lastLastIndex = lastIndex, output.length >= lim)); ) separatorCopy.lastIndex === match.index && separatorCopy.lastIndex++;
        return lastLastIndex === string.length ? !lastLength && exec$3(separatorCopy, "") || push$3(output, "") : push$3(output, stringSlice$5(string, lastLastIndex)), 
        output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    } : "0".split(void 0, 0).length ? function(separator, limit) {
        return void 0 === separator && 0 === limit ? [] : functionCall(nativeSplit, this, separator, limit);
    } : nativeSplit, [ function(separator, limit) {
        var O = requireObjectCoercible(this), splitter = isNullOrUndefined(separator) ? void 0 : getMethod(separator, SPLIT);
        return splitter ? functionCall(splitter, separator, O, limit) : functionCall(internalSplit, toString_1(O), separator, limit);
    }, function(string, limit) {
        var rx = anObject(this), S = toString_1(string), res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
        var C = speciesConstructor(rx, RegExp), unicodeMatching = rx.unicode, flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (UNSUPPORTED_Y$3 ? "g" : "y"), splitter = new C(UNSUPPORTED_Y$3 ? "^(?:" + rx.source + ")" : rx, flags), lim = void 0 === limit ? 4294967295 : limit >>> 0;
        if (0 === lim) return [];
        if (0 === S.length) return null === regexpExecAbstract(splitter, S) ? [ S ] : [];
        for (var p = 0, q = 0, A = []; q < S.length; ) {
            splitter.lastIndex = UNSUPPORTED_Y$3 ? 0 : q;
            var e, z = regexpExecAbstract(splitter, UNSUPPORTED_Y$3 ? stringSlice$5(S, q) : S);
            if (null === z || (e = min$2(toLength(splitter.lastIndex + (UNSUPPORTED_Y$3 ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching); else {
                if (push$3(A, stringSlice$5(S, p, q)), A.length === lim) return A;
                for (var i = 1; i <= z.length - 1; i++) if (push$3(A, z[i]), A.length === lim) return A;
                q = p = e;
            }
        }
        return push$3(A, stringSlice$5(S, p)), A;
    } ];
}), !!fails((function() {
    var re = /(?:)/, originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return 2 !== result.length || "a" !== result[0] || "b" !== result[1];
})), UNSUPPORTED_Y$3);

var floor$1 = Math.floor, charAt$6 = functionUncurryThis("".charAt), replace$5 = functionUncurryThis("".replace), stringSlice$6 = functionUncurryThis("".slice), SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g, getSubstitution = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length, m = captures.length, symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    return void 0 !== namedCaptures && (namedCaptures = toObject(namedCaptures), symbols = SUBSTITUTION_SYMBOLS), 
    replace$5(replacement, symbols, (function(match, ch) {
        var capture;
        switch (charAt$6(ch, 0)) {
          case "$":
            return "$";

          case "&":
            return matched;

          case "`":
            return stringSlice$6(str, 0, position);

          case "'":
            return stringSlice$6(str, tailPos);

          case "<":
            capture = namedCaptures[stringSlice$6(ch, 1, -1)];
            break;

          default:
            var n = +ch;
            if (0 === n) return match;
            if (n > m) {
                var f = floor$1(n / 10);
                return 0 === f ? match : f <= m ? void 0 === captures[f - 1] ? charAt$6(ch, 1) : captures[f - 1] + charAt$6(ch, 1) : match;
            }
            capture = captures[n - 1];
        }
        return void 0 === capture ? "" : capture;
    }));
}, REPLACE = wellKnownSymbol("replace"), max$3 = Math.max, min$3 = Math.min, concat$2 = functionUncurryThis([].concat), push$4 = functionUncurryThis([].push), stringIndexOf$1 = functionUncurryThis("".indexOf), stringSlice$7 = functionUncurryThis("".slice), REPLACE_KEEPS_$0 = "$0" === "a".replace(/./, "$0"), REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = !!/./[REPLACE] && "" === /./[REPLACE]("a", "$0");

fixRegexpWellKnownSymbolLogic("replace", (function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [ function(searchValue, replaceValue) {
        var O = requireObjectCoercible(this), replacer = isNullOrUndefined(searchValue) ? void 0 : getMethod(searchValue, REPLACE);
        return replacer ? functionCall(replacer, searchValue, O, replaceValue) : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    }, function(string, replaceValue) {
        var rx = anObject(this), S = toString_1(string);
        if ("string" == typeof replaceValue && -1 === stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) && -1 === stringIndexOf$1(replaceValue, "$<")) {
            var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
            if (res.done) return res.value;
        }
        var functionalReplace = isCallable(replaceValue);
        functionalReplace || (replaceValue = toString_1(replaceValue));
        var global = rx.global;
        if (global) {
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
        }
        for (var results = []; ;) {
            var result = regexpExecAbstract(rx, S);
            if (null === result) break;
            if (push$4(results, result), !global) break;
            "" === toString_1(result[0]) && (rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode));
        }
        for (var it, accumulatedResult = "", nextSourcePosition = 0, i = 0; i < results.length; i++) {
            for (var matched = toString_1((result = results[i])[0]), position = max$3(min$3(toIntegerOrInfinity(result.index), S.length), 0), captures = [], j = 1; j < result.length; j++) push$4(captures, void 0 === (it = result[j]) ? it : String(it));
            var namedCaptures = result.groups;
            if (functionalReplace) {
                var replacerArgs = concat$2([ matched ], captures, position, S);
                void 0 !== namedCaptures && push$4(replacerArgs, namedCaptures);
                var replacement = toString_1(functionApply(replaceValue, void 0, replacerArgs));
            } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
            position >= nextSourcePosition && (accumulatedResult += stringSlice$7(S, nextSourcePosition, position) + replacement, 
            nextSourcePosition = position + matched.length);
        }
        return accumulatedResult + stringSlice$7(S, nextSourcePosition);
    } ];
}), !!fails((function() {
    var re = /./;
    return re.exec = function() {
        var result = [];
        return result.groups = {
            a: "7"
        }, result;
    }, "7" !== "".replace(re, "$<a>");
})) || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var METHOD_NAME, whitespaces = "\t\n\v\f\r                　\u2028\u2029\ufeff", replace$6 = functionUncurryThis("".replace), whitespace = "[" + whitespaces + "]", ltrim = RegExp("^" + whitespace + whitespace + "*"), rtrim = RegExp(whitespace + whitespace + "*$"), createMethod$3 = function(TYPE) {
    return function($this) {
        var string = toString_1(requireObjectCoercible($this));
        return 1 & TYPE && (string = replace$6(string, ltrim, "")), 2 & TYPE && (string = replace$6(string, rtrim, "")), 
        string;
    };
}, stringTrim = {
    start: createMethod$3(1),
    end: createMethod$3(2),
    trim: createMethod$3(3)
}, PROPER_FUNCTION_NAME$2 = functionName.PROPER, $trim = stringTrim.trim;

_export({
    target: "String",
    proto: !0,
    forced: (METHOD_NAME = "trim", fails((function() {
        return !!whitespaces[METHOD_NAME]() || "​᠎" !== "​᠎"[METHOD_NAME]() || PROPER_FUNCTION_NAME$2 && whitespaces[METHOD_NAME].name !== METHOD_NAME;
    })))
}, {
    trim: function() {
        return $trim(this);
    }
});

var bundle_config = createCommonjsModule((function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = {
        "com.yitan.lite": {
            appId: 10,
            platform: 6,
            productId: 130
        },
        "com.yitan.bixin": {
            appId: 10,
            platform: 1,
            productId: 100
        },
        "com.yitantech.gaigai": {
            appId: 10,
            platform: 2,
            productId: 100
        },
        "com.yitantech.gaigaienter": {
            appId: 10,
            platform: 1,
            productId: 110
        },
        "com.yitan.chuke": {
            appId: 10,
            platform: 1,
            productId: 120
        },
        "com.yupp.yuer": {
            appId: 20,
            platform: 1,
            productId: 200
        },
        "com.yupaopao.yuer": {
            appId: 20,
            platform: 2,
            productId: 200
        },
        "com.wywk.yupaopao": {
            appId: 20,
            platform: 1,
            productId: 210
        },
        "cn.yupaopao.crop": {
            appId: 10,
            platform: 3,
            productId: 110
        },
        "php-activity": {
            appId: 20,
            platform: 5,
            productId: 200
        },
        "com.yangle.xiaoxingqiu": {
            appId: 30,
            platform: 2,
            productId: 300
        },
        "com.yitan.universe": {
            appId: 30,
            platform: 5,
            productId: 300
        },
        "com.yangle.xiaoyuzhou": {
            appId: 30,
            platform: 2,
            productId: 300
        },
        "com.yitantech.yuerent": {
            appId: 20,
            platform: 1,
            productId: 240
        },
        "pc.yupaopao.yuer": {
            appId: 20,
            platform: 3,
            productId: 250
        },
        "pc.yupaopao.bixin": {
            appId: 10,
            platform: 3,
            productId: 150
        },
        "com.yangle.xiaoxingqiuent": {
            appId: 30,
            platform: 2,
            productId: 300
        },
        "node.yupaopao.yuer": {
            appId: 20,
            platform: 7,
            productId: 240
        },
        "node.yupaopao.bixin": {
            appId: 10,
            platform: 7,
            productId: 140
        },
        "php.yupaopao.yuer": {
            appId: 20,
            platform: 7,
            productId: 260
        },
        "php.yupaopao.bixin": {
            appId: 10,
            platform: 7,
            productId: 160
        },
        "pc.yangle.xiaoxingqiu": {
            appId: 30,
            platform: 3,
            productId: 350
        },
        "node.xiaoxingqiu.union": {
            appId: 30,
            platform: 7,
            productId: 340
        },
        "node.yuer.home": {
            appId: 20,
            platform: 7,
            productId: 240
        },
        "node.bixin.home": {
            appId: 10,
            platform: 7,
            productId: 140
        },
        "node.bixin.h5": {
            appId: 10,
            platform: 7,
            productId: 140
        },
        "node.yuer.h5": {
            appId: 20,
            platform: 7,
            productId: 240
        },
        "node.xiaoxingqiu.h5": {
            appId: 30,
            platform: 7,
            productId: 340
        },
        "com.universe.helper": {
            appId: 30,
            platform: 2,
            productId: 370
        },
        "com.yitantech.yrlivehelper": {
            appId: 30,
            platform: 1,
            productId: 370
        },
        "com.yitantech.livehelper": {
            appId: 30,
            platform: 1,
            productId: 370
        },
        "com.yitan.tangguo": {
            appId: 80,
            platform: 1,
            productId: 800
        },
        "com.yitan.tangguoTest": {
            appId: 80,
            platform: 1,
            productId: 810
        },
        "node.tangguo.h5": {
            appId: 80,
            platform: 7,
            productId: 820
        },
        "com.yupaopao.android.hug": {
            appId: 10,
            platform: 2,
            productId: 170
        },
        "com.yitan.hug": {
            appId: 10,
            platform: 1,
            productId: 170
        },
        "com.yitan.arhug": {
            appId: 250,
            platform: 1,
            productId: 2500
        },
        "com.yitan.android.arhug": {
            appId: 250,
            platform: 2,
            productId: 2500
        },
        "com.yitan.yalo": {
            appId: 250,
            platform: 1,
            productId: 2500
        },
        "com.yitantech.zaixin": {
            appId: 10,
            platform: 1,
            productId: 111
        },
        "com.yitantech.yuerlive": {
            appId: 30,
            platform: 1,
            productId: 300
        },
        "com.yitan.penta": {
            appId: 100,
            platform: 1,
            productId: 1e3
        },
        "com.yitantech.penta": {
            appId: 100,
            platform: 2,
            productId: 1e3
        },
        "com.zaixin.yep": {
            appId: 100,
            platform: 1,
            productId: 1e3
        },
        "com.zaixin.mvp": {
            appId: 110,
            platform: 1,
            productId: 1100
        },
        "com.yixian.iosclient": {
            appId: 110,
            platform: 1,
            productId: 1100
        },
        "com.connxun.elinetv": {
            appId: 110,
            platform: 1,
            productId: 1100
        },
        "com.zaixintech.mvp": {
            appId: 110,
            platform: 2,
            productId: 1100
        },
        "node.mvp.h5": {
            appId: 110,
            platform: 7,
            productId: 1110
        },
        "com.yitan.live.overseas": {
            appId: 130,
            platform: 1,
            productId: 1300
        },
        "com.yitantech.live.overseas": {
            appId: 130,
            platform: 2,
            productId: 1300
        },
        "com.yixian.zhiyu": {
            appId: 140,
            platform: 1,
            productId: 1400
        },
        "com.yitantech.chuke": {
            appId: 140,
            platform: 2,
            productId: 1400
        },
        "node.chuke.h5": {
            appId: 140,
            platform: 7,
            productId: 1410
        },
        "pc.yitantech.chuke": {
            appId: 140,
            platform: 3,
            productId: 1450
        },
        "com.jctd.iphoneclient": {
            appId: 150,
            platform: 1,
            productId: 1500
        },
        "com.jctd.andoridclient": {
            appId: 150,
            platform: 2,
            productId: 1500
        },
        "node.jctd.h5": {
            appId: 150,
            platform: 7,
            productId: 1510
        },
        "com.matrixapp.iosclient": {
            appId: 170,
            platform: 1,
            productId: 1700
        },
        "com.matrixapp.androidclient": {
            appId: 170,
            platform: 2,
            productId: 1700
        },
        "com.yitan.tayu": {
            appId: 190,
            platform: 1,
            productId: 1900
        },
        "com.yitantech.tayuapp": {
            appId: 190,
            platform: 2,
            productId: 1900
        },
        "node.tayu.h5": {
            appId: 190,
            platform: 7,
            productId: 1910
        },
        "com.ft.iphoneclient": {
            appId: 220,
            platform: 2,
            productId: 2200
        },
        "com.ft.androidclient": {
            appId: 220,
            platform: 1,
            productId: 2200
        }
    };
}));

unwrapExports(bundle_config);

var name_config = createCommonjsModule((function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = {
        bixin: "比心",
        yrlivehelper: "手游直播助手",
        yuer: "鱼耳语音",
        xxq: "鱼耳直播",
        penta: "耶扑",
        mvp: "MVP",
        tangguo: "糖果",
        hug: "比心海外版",
        YaloLive: "YaloLive",
        YaloLivePro: "YaloLivePro",
        liveOverseas: "比心海外直播",
        "pc-live": "PC直播",
        "pc-chatroom": "PC聊天室",
        "pc-zhiyu-chatroom": "吱语PC聊天室",
        node: "node",
        chuke: "吱语",
        tayu: "他语",
        ypp: "矩阵",
        st: "K歌星球",
        fantang: "饭糖"
    };
}));

unwrapExports(name_config);

var config = createCommonjsModule((function(module, exports) {
    var _a, _b, _c, _d, _e, _f, _g, _h, __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
        return (__assign = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) for (var p in s = arguments[i]) Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
            return t;
        }).apply(this, arguments);
    }, __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            default: mod
        };
    };
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.hostSchemeMap = exports.bundleSchemeMap = exports.nameConfig = exports.bundleConfig = void 0;
    var bundle_config_1 = __importDefault(bundle_config), name_config_1 = __importDefault(name_config), bundleConfig = bundle_config_1.default;
    exports.bundleConfig = bundleConfig;
    var nameConfig = name_config_1.default;
    exports.nameConfig = nameConfig;
    var bundleSchemeMap = {};
    exports.bundleSchemeMap = bundleSchemeMap;
    var hostSchemeMap = {};
    if (exports.hostSchemeMap = hostSchemeMap, "undefined" != typeof window) {
        var win = window;
        (null === (_b = null === (_a = null == win ? void 0 : win.CYPP) || void 0 === _a ? void 0 : _a.ua) || void 0 === _b ? void 0 : _b.bundleConfig) && (exports.bundleConfig = bundleConfig = __assign(__assign({}, bundle_config_1.default), win.CYPP.ua.bundleConfig)), 
        (null === (_d = null === (_c = null == win ? void 0 : win.CYPP) || void 0 === _c ? void 0 : _c.ua) || void 0 === _d ? void 0 : _d.nameConfig) && (exports.nameConfig = nameConfig = __assign(__assign({}, name_config_1.default), win.CYPP.ua.nameConfig)), 
        (null === (_f = null === (_e = null == win ? void 0 : win.CYPP) || void 0 === _e ? void 0 : _e.ua) || void 0 === _f ? void 0 : _f.bundleSchemeMap) && (exports.bundleSchemeMap = bundleSchemeMap = win.CYPP.ua.bundleSchemeMap), 
        (null === (_h = null === (_g = null == win ? void 0 : win.CYPP) || void 0 === _g ? void 0 : _g.ua) || void 0 === _h ? void 0 : _h.hostSchemeMap) && (exports.hostSchemeMap = hostSchemeMap = win.CYPP.ua.hostSchemeMap);
    }
}));

unwrapExports(config);

config.hostSchemeMap, config.bundleSchemeMap, config.nameConfig, config.bundleConfig;

var parse_1 = createCommonjsModule((function(module, exports) {
    var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
        return (__assign = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) for (var p in s = arguments[i]) Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
            return t;
        }).apply(this, arguments);
    };
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.parse = void 0;
    var R_YPP = /^(.*?)bridge\/([\d\.]+) \((.*?)\)/, R_IOS = /(iPhone|iPad|iPod|iOS)/i, R_ANDROID = /android/i, R_OTHER_MOBILE = /BlackBerry|Opera Mini|IEMobile/i, R_WECHAT = /MicroMessenger/i, R_WEIBO = /(\bWeibo\b|WeiboIntlAndroid|WeiboIntliOS)/i, R_ALIPAY = /Alipay/;
    function _parse(arr, field) {
        return field.trim().split(/\s*;\s*/).reduce((function(res, key, i) {
            var value = arr[i];
            if (null != value) {
                if ("bundle" === key) {
                    var parts = value.split(" ");
                    value = {
                        id: parts[0],
                        version: parts[1]
                    };
                } else if ("appInfo" === key) {
                    var parts_1 = value.split(" "), toInt = function(index) {
                        return parseInt(parts_1[index], 10);
                    };
                    value = {
                        statusHeight: toInt(0),
                        navbarHeight: toInt(1),
                        width: toInt(2),
                        height: toInt(3)
                    };
                } else if ("platformInfo" === key) {
                    parts = value.split(" ");
                    value = {
                        scheme: parts[0],
                        appName: parts[1] ? decodeURI(parts[1]) : "",
                        appId: parts[2] ? parseInt(parts[2], 10) : null
                    };
                }
                res[key] = value;
            }
            return res;
        }), {});
    }
    function includes(str, part) {
        return str.indexOf(part) >= 0;
    }
    function getProductId(bundleId) {
        var _a;
        return config.bundleConfig[bundleId] ? null === (_a = config.bundleConfig[bundleId]) || void 0 === _a ? void 0 : _a.productId : 0;
    }
    exports.parse = function(ua) {
        var _a, _b, _c, _d, originUa = ua, yppAppName = null, ypp = null, _appId = null, _productId = null;
        R_YPP.test(ua) && (ua = RegExp.$1, yppAppName = function(bundleId, isPc) {
            if (370 === getProductId(bundleId)) return "yrlivehelper";
            var inc = function(part) {
                return includes(bundleId, part);
            }, app = null;
            inc("bixin") ? app = "bixin" : inc("yuer") || inc(".wywk.") ? app = "yuer" : inc("xiaoxingqiu") || inc("xiaoyuzhou") || inc("universe") || inc("yrlive") ? app = "xxq" : inc("ft.iphoneclient") || inc("ft.androidclient") ? app = "fantang" : inc("tangguo") ? app = "tangguo" : inc("yalo") ? app = "YaloLivePro" : inc("arhug") ? app = "YaloLive" : inc("hug") ? app = "hug" : inc("penta") || inc("yep") ? app = "penta" : inc("chuke") || inc("zhiyu") ? app = "chuke" : inc("tayu") ? app = "tayu" : inc("mvp") || inc("yixian") || inc("connxun") ? app = "mvp" : inc("live.overseas") ? app = "liveOverseas" : inc("jctd") ? app = "st" : inc("matrixapp") ? app = "ypp" : (inc(".yitantech.") || inc(".yitan.")) && (app = "bixin");
            for (var key in config.bundleSchemeMap) inc(key) && (app = config.bundleSchemeMap[key]);
            if (isPc) return "chuke" === app ? "pc-zhiyu-chatroom" : "xxq" === app ? "pc-live" : "pc-chatroom";
            return app;
        }((ypp = function(version, detailArray) {
            var detail;
            detail = parseInt(version[0], 10) >= 3 ? function(detailArray) {
                return _parse(detailArray, "bundle; accessToken; udid; network; equipment; osInfo; channel; appInfo; mockUid; sysLang; userLang; platformInfo");
            }(detailArray) : function(detailArray) {
                return _parse(detailArray, "bundle; token; accessToken; udid; salt; network; equipment; osInfo; channel; appInfo; sysLang; userLang; platformInfo");
            }(detailArray);
            return __assign(__assign({}, detail), {
                version: version
            });
        }(RegExp.$2, RegExp.$3.split(";"))).bundle.id, "PC" === ypp.equipment) || (null === (_a = null == ypp ? void 0 : ypp.platformInfo) || void 0 === _a ? void 0 : _a.scheme) || null, 
        _appId = function(bundleId) {
            var _a;
            return config.bundleConfig[bundleId] ? null === (_a = config.bundleConfig[bundleId]) || void 0 === _a ? void 0 : _a.appId : null;
        }(ypp.bundle.id) || null, _productId = getProductId(ypp.bundle.id) || null);
        var isYpp = !!yppAppName, isYppPC = !!ypp && "PC" === ypp.equipment, isYppMC = isYpp && !isYppPC, platformCode = yppAppName || function() {
            try {
                var host_1 = location.host, inc = function(part) {
                    return includes(host_1, part);
                }, app = null;
                for (var key in inc("bixin") ? app = "bixin" : inc("bxyuer") ? app = "yuer" : inc("xxq") || inc("yuerzhibo") ? app = "xxq" : inc("fantang") ? app = "fantang" : inc("bxyep") ? app = "penta" : inc("chuke") || inc("zhiyu") ? app = "chuke" : inc("tayu") ? app = "tayu" : inc("zaixinmvp") || inc("1-xian") ? app = "mvp" : inc("gxjunxiao") ? app = "st" : inc("matrixapp") && (app = "ypp"), 
                config.hostSchemeMap) inc(key) && (app = config.hostSchemeMap[key]);
                return app;
            } catch (e) {
                return "node";
            }
        }(), platformName = (null === (_b = null == ypp ? void 0 : ypp.platformInfo) || void 0 === _b ? void 0 : _b.appName) || config.nameConfig[platformCode || ""], appId = (null === (_c = null == ypp ? void 0 : ypp.platformInfo) || void 0 === _c ? void 0 : _c.appId) || _appId, productId = _productId || null, info = __assign({
            width: 0,
            height: 0
        }, ypp ? ypp.appInfo : {}), screenWidth = info.width, screenHeight = info.height;
        "undefined" != typeof window && (screenWidth = window.screen.width, screenHeight = window.screen.height);
        var app = {
            ua: originUa,
            name: yppAppName,
            platformName: platformName,
            platformCode: platformCode,
            appId: appId,
            productId: productId,
            isYppPC: isYppPC,
            isYppMC: isYppMC,
            isYpp: isYpp,
            isBixin: "bixin" === yppAppName || "hug" === yppAppName || "penta" === yppAppName,
            isYuer: "yuer" === yppAppName,
            isMatrix: "ypp" === yppAppName,
            isHug: "hug" === yppAppName,
            isYaLoLive: "YaloLive" === yppAppName,
            isYaLoLivePro: "YaloLivePro" === yppAppName,
            isMvp: "mvp" === yppAppName,
            isPenTa: "penta" === yppAppName,
            isLiveOverseas: "liveOverseas" === yppAppName,
            isXxq: "xxq" === yppAppName || "liveOverseas" === yppAppName,
            isYrlive: "xxq" === yppAppName || "liveOverseas" === yppAppName,
            isYrlivehelper: "yrlivehelper" === yppAppName,
            isTangguo: "tangguo" === yppAppName,
            isChuke: "chuke" === yppAppName,
            isTayu: "tayu" === yppAppName,
            isSt: "st" === yppAppName,
            isFantang: "fantang" === yppAppName,
            isPcChatroom: "pc-chatroom" === yppAppName,
            isZhiyuPcChatroom: "pc-zhiyu-chatroom" === yppAppName,
            isPcLive: "pc-live" === yppAppName,
            isWechat: R_WECHAT.test(ua),
            isWeibo: R_WEIBO.test(ua),
            isAlipay: R_ALIPAY.test(ua),
            isIPhoneX: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua) && screenWidth >= 375 && screenHeight >= 812
        };
        if (null === (_d = null == ypp ? void 0 : ypp.platformInfo) || void 0 === _d ? void 0 : _d.scheme) {
            var _str = ypp.platformInfo.scheme;
            app["is" + _str.replace(_str[0], _str[0].toUpperCase())] = !0;
        }
        var isIOS = R_IOS.test(ua), isAndroid = R_ANDROID.test(ua);
        return {
            system: {
                isIOS: isIOS,
                isAndroid: isAndroid,
                isMobile: isIOS || isAndroid || R_OTHER_MOBILE.test(ua)
            },
            app: app,
            ypp: ypp
        };
    };
}));

unwrapExports(parse_1);

var parse_2 = parse_1.parse;

function compareVersion(version1, version2) {
    for (var arr1 = version1.split("."), arr2 = version2.split("."), len1 = arr1.length, len2 = arr2.length, minLength = Math.min(len1, len2), i = 0; i < minLength; i++) {
        var diff = parseInt(arr1[i], 10) - parseInt(arr2[i], 10);
        if (0 !== diff) return diff;
    }
    return len1 < len2 ? -1 : len1 > len2 ? 1 : 0;
}

function getEnvObject(options) {
    void 0 === options && (options = {});
    var prefix = function(isTestOrEnv, options) {
        void 0 === options && (options = {});
        var prefix = "";
        if ("boolean" == typeof isTestOrEnv) prefix = isTestOrEnv ? "test" : ""; else if ("string" == typeof isTestOrEnv) prefix = "prod" === isTestOrEnv ? "" : isTestOrEnv; else {
            var host = options.host || ("undefined" != typeof location ? location.host : "");
            /^uat[-.]/.test(host) ? prefix = "uat" : (/^test[-.]/.test(host) || /^localhost/.test(host) || /^\d+(\.\d+){3}/.test(host)) && (prefix = "test");
        }
        return options.enableUat || "uat" !== prefix || (prefix = ""), prefix + (prefix ? "-" : "");
    }(null, __assign({
        enableUat: !0
    }, options));
    return {
        name: prefix.replace("-", "") || "prod",
        prefix: prefix,
        isTest: "test-" === prefix,
        isUat: "uat-" === prefix,
        isProd: "" === prefix,
        ssr: preEnvSSRObject(options)
    };
}

function preEnvSSRObject(options) {
    var initRouterBase = "";
    return initRouterBase = "undefined" != typeof window ? window.__WATT_ROUTER_BASE__ || "" : options.__WATT_ROUTER_BASE__ || "", 
    "undefined" != typeof location && "undefined" != typeof navigator ? getEnvSSRObject(navigator.userAgent, location.pathname, location.href, initRouterBase) : getEnvSSRObject(options.userAgent, options.path, options.href, initRouterBase);
}

function getEnvSSRObject(userAgent, locationPath, locationHref, initRouterBase) {
    void 0 === userAgent && (userAgent = ""), void 0 === locationPath && (locationPath = ""), 
    void 0 === locationHref && (locationHref = ""), void 0 === initRouterBase && (initRouterBase = "");
    var routerBase = "", routerPath = locationPath;
    initRouterBase ? (routerBase = initRouterBase, routerPath = locationPath.replace(initRouterBase, "")) : /^(.*?\/index(?:\.html)?)\b(.*)$/.test(locationPath) && (routerBase = RegExp.$1, 
    routerPath = RegExp.$2);
    var requestPrefix, str, part, url = locationHref.split(/[#?]/)[0], suffix = routerBase + routerPath;
    part = suffix, requestPrefix = (str = url).substr(str.length - part.length) === part ? url.substr(0, url.length - suffix.length) : url.replace(/\/$/, ""), 
    routerPath || (routerPath = "/");
    var search = locationHref.replace(/#.*$/, "").split("?")[1];
    return search && (routerPath += "?" + search), {
        routerBase: routerBase,
        routerPath: routerPath,
        requestPrefix: requestPrefix,
        userAgent: userAgent
    };
}

var FUNCTION_NAME_EXISTS = functionName.EXISTS, defineProperty$8 = objectDefineProperty.f, FunctionPrototype$3 = Function.prototype, functionToString$1 = functionUncurryThis(FunctionPrototype$3.toString), nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, regExpExec = functionUncurryThis(nameRE.exec);

descriptors && !FUNCTION_NAME_EXISTS && defineProperty$8(FunctionPrototype$3, "name", {
    configurable: !0,
    get: function() {
        try {
            return regExpExec(nameRE, functionToString$1(this))[1];
        } catch (error) {
            return "";
        }
    }
});

var url = require("url"), noError = function createProxy(fn) {
    return new Proxy(fn, {
        get: function() {
            return createProxy(fn);
        }
    });
}(noop$1), YPP = null;

function Tracker() {
    return noError;
}

function noop$1() {}

exports.createYPP = function(options) {
    var location = url.parse(options.fullUrl), uaParams = parse_2(options.userAgent), app = uaParams.app, system = uaParams.system, env = getEnvObject({
        host: location.host || "",
        href: options.fullUrl,
        path: location.pathname || "",
        userAgent: options.userAgent
    }), bridge = function(bridge) {
        return new Proxy(bridge, {
            get: function(target, propKey, receiver) {
                return target.hasOwnProperty(propKey) ? Reflect.get(target, propKey, receiver) : noError;
            }
        });
    }(function(_a) {
        var ypp = _a.ypp, app = _a.app, system = _a.system;
        function _getVersion(isBundle) {
            return ypp ? isBundle ? ypp.bundle.version : ypp.version : null;
        }
        return {
            isServer: "undefined" == typeof window,
            ua: app.ua,
            isIOS: system.isIOS,
            isAndroid: system.isAndroid,
            isInYpp: app.isYpp,
            subject: app.name,
            detail: ypp,
            version: ypp ? ypp.version : null,
            app: app,
            ltVersion: function(version, isBundle) {
                void 0 === isBundle && (isBundle = !1);
                var v = _getVersion(isBundle);
                return v ? compareVersion(v, version) < 0 : null;
            },
            lteVersion: function(version, isBundle) {
                void 0 === isBundle && (isBundle = !1);
                var v = _getVersion(isBundle);
                return v ? compareVersion(v, version) <= 0 : null;
            },
            gtVersion: function(version, isBundle) {
                void 0 === isBundle && (isBundle = !1);
                var v = _getVersion(isBundle);
                return v ? compareVersion(v, version) > 0 : null;
            },
            gteVersion: function(version, isBundle) {
                void 0 === isBundle && (isBundle = !1);
                var v = _getVersion(isBundle);
                return v ? compareVersion(v, version) >= 0 : null;
            }
        };
    }(uaParams)), hybrid = noError, perf = noError;
    return env.ssr = __assign(__assign({}, env.ssr), options), YPP = {
        platform: system,
        app: app,
        env: env,
        perf: perf,
        Tracker: Tracker,
        track: noop$1,
        trackVolc: noop$1,
        trackConfig: noop$1,
        trackPageView: noop$1,
        batchTrackStart: noop$1,
        batchTrackEnd: noop$1,
        trackBI: noop$1,
        reportError: noop$1,
        mcBridge: bridge,
        pcBridge: bridge,
        hybrid: hybrid,
        install: function(Vue) {
            Vue.$bridge = Vue.prototype.$bridge = bridge, Vue.$mc = Vue.prototype.$mc = bridge, 
            Vue.$pc = Vue.prototype.$pc = bridge, Vue.$hybrid = Vue.prototype.$hybrid = hybrid, 
            Vue.$perf = Vue.prototype.$perf = perf, Vue.$YPP = Vue.prototype.$YPP = YPP;
        }
    };
}, exports.getYPP = function() {
    return YPP;
};
